<template>
  <div
      id="chat-app"
      class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden vs-con-loading__container"
  >
    <div id="chat-app-loading"></div>
    <vs-popup
        title="Atendimentos Transferidos / Recebidos"
        :active.sync="transferredChatsPopup"
        class="sizePopup"
    >
      <div
          v-for="(tChat, index) in transferredChats"
          :key="`transferred-chat-${index}`"
          class="transferred-chat"
      >
        <div>
          <h4>{{ tChat.dialogTitle }}</h4>
          <h6>{{ formattedDate(tChat.date) }}</h6>
        </div>

        <p>{{ tChat.dialogText }}</p>
      </div>
    </vs-popup>

    <vs-popup
        title="Transferência de atendimento"
        :active.sync="ticketTransferPopup"
        v-if="ticketTransfer"
    >
      <div class="text-center">
        <vs-row class="mt-2">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <span>
              <span color="text-primary">{{ ticketTransfer.next_user_name }}</span>
                pediu o atendimento de
              <span color="text-primary">
                {{ ticketTransfer.customer_name }} {{ ticketTransfer.customer_phone_number }}
              </span>
                na conexão
              <span color="text-primary">{{ ticketTransfer.instance_name }}</span>
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mt-2">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <span>
              Se não houver resposta em
              <vue-countdown :time="timer" v-slot="{ minutes, seconds }">
                  <span class="text-primary"> {{ minutes }}:{{ seconds }}</span>
              </vue-countdown>
              o atendimento será transferido automaticamente.
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4 mb-4">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
                class="ticket-transfer-span"
                @click.prevent="refuseTicketTransfer"
            >
              <span>
                NEGAR
              </span>
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
                class="ticket-transfer-span"
                @click.prevent="confirmTicketTransfer"
            >
              <span>
                ACEITAR
              </span>
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-sidebar
        class="items-no-padding"
        parent="#chat-app"
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="isChatSidebarActive"
        id="chat-list-sidebar"
    >
      <!-- USER PROFILE SIDEBAR -->
      <user-profile
          :active="activeProfileSidebar"
          :profile-object="profileObject"
          class="user-profile-container"
          :isLoggedInUser="isLoggedInUserProfileView"
          @closeProfileSidebar="closeProfileSidebar"
          @reloadChatTab="reloadChatTab"
          @updateChatNavbarWithNewData="updateChatNavbarWithNewData"
          @openActiveChatUser="openActiveChatUser"
      />

      <get-order-by-msg
        :order="orders"
        :chat="whichChat"
        v-if="hasCatalogFeature"
        :isSidebarActive="addNewDataSidebar"
        @closeSidebar="toggleDataSidebar"
      />

      <!-- NEW CHAT SIDEBAR -->
      <new-chat
          :active="activeNewChatSidebar"
          class="new-chat-container"
          @toggleNewChatSidebar="toggleNewChatSidebar"
          @closeNewChatSidebar="closeNewChatSidebar"
          @updateActiveChatUser="updateActiveChatUser"
      />
      <h5 class="mb-1 connection-active"> {{ activeInstance }} </h5>
      <div class="ml-2 mb-2 flex items-center justify-center">
        <VsDropdown :vs-trigger-click="isSmallScreen">
          <vs-button
            icon-after
            icon-pack="feather"
            icon="icon-sliders"
            class="btn-drop px-3 attendance-span"
            :type="chatsBeFilled ? 'filled' : 'border'"
            style="width: calc(400px - 2.5rem); font-size:1rem !important"
          >Filtros</vs-button>

          <VsDropdownMenu>
            <vs-collapse class="select-none" accordion>
              <vs-collapse-item open>
                <div slot="header">Atendimentos</div>

                <li class="mb-2" @touchstart="setChatOrigin('all')" @click="setChatOrigin('all')">
                  <vs-radio color="primary" vs-value="all" v-model="chatFilter">
                    Todos
                  </vs-radio>
                </li>
                <li class="mb-2" @touchstart="setChatOrigin('attendance')" @click="setChatOrigin('attendance')">
                  <vs-radio color="primary" vs-value="attendance" v-model="chatFilter">
                    Atendimentos
                  </vs-radio>
                </li>
                <li class="mb-2" @touchstart="setChatOrigin('campaign')" @click="setChatOrigin('campaign')">
                  <vs-radio color="primary" vs-value="campaign" v-model="chatFilter">
                    Campanhas
                  </vs-radio>
                </li>
                <li class="mb-2" @touchstart="setChatOrigin('maria')" @click="setChatOrigin('maria')">
                  <vs-radio color="primary" vs-value="maria" v-model="chatFilter">
                    Maria
                  </vs-radio>
                </li>
                <li class="mb-2" @touchstart="!otherChatsOpened ? setChatOrigin('unseenMsg') : null" @click="!otherChatsOpened ? setChatOrigin('unseenMsg') : null">
                  <vs-radio :disabled="otherChatsOpened" v-model="chatFilter" vs-value="unseenMsg" color="primary">
                    Mensagens não lidas
                  </vs-radio>
                </li>
                <li class="mb-2 mt-4" @touchstart.prevent="customNotifyUnseenMsgFilter" @click="notifyUnseenMsgFilter">
                  <vs-checkbox
                    ref="npsFilterCheckbox"
                    class="ml-0"
                    color="primary"
                    vs-value="search"
                    v-model="additionalChatFilter"
                    :disabled="chatFilter === 'unseenMsg'"
                  >
                    + Pesquisa NPS
                  </vs-checkbox>
                </li>
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header" @click.prevent="setDefaultFilters">Categorias</div>
                <customer-category-slim-list checkbox minimum :selecteds="filterGroups" @selectedGroup="updateFilterGroups"/>
                <div class="mt-1">
                  <vs-button size="small" class="mr-2" :disabled="!filterGroups.length" @click.prevent="reloadChatByFilter()">Salvar</vs-button>
                  <vs-button size="small" color="danger" class="mt-1" :disabled="!hasGroupFilter" @click.prevent="updateFilterGroups([],true)">Limpar</vs-button>
                </div>
              </vs-collapse-item>
              <vs-collapse-item v-if="unifyConnections">
                <div slot="header" @click.prevent="setDefaultFilters">Conexões</div>
                <instances-slim-list minimum checkbox showNickname :selecteds="filterInstances" @selectedInstances="updateFilterInstances"/>
                <vs-button size="small" class="mt-1" :disabled="!filterInstances.length" @click.prevent="reloadChatByFilter()">Salvar</vs-button>
              </vs-collapse-item>
            </vs-collapse>
          </VsDropdownMenu>
        </VsDropdown>
      </div>
      <div class="chat__profile-search flex p-4" :style="'margin-top: -13px'">
        <div class="ml-2 flex items-center justify-center">
          <inbox-button @openInboxChats="openOtherChats('inbox')" @updateInboxChatSum="updateInboxChatSum"/>

          <button
              type="button"
              name="button"
              :class=" !finishedTickets
                ? 'vs-component align-right vs-button vs-button-primary vs-button-filled mr-2'
                : 'vs-component align-right vs-button vs-button-primary vs-button-border mr-2'
            "
              style="background: transparent none repeat scroll 0% 0%"
              @click.prevent="openMyChats"
          >
            <span class="vs-button-text vs-button--text attendance-span">
              <span>MEUS ATENDIMENTOS ABERTOS</span>
            </span>
            <span class="vs-button-linex notification" >
              <small> {{myChatsSum}} </small>
            </span>
          </button>
          <VsDropdown :vs-trigger-click="isSmallScreen">
            <vs-button
                class="btn-drop px-3 attendance-span"
                :type="otherChatsShouldBeFilled ? 'filled' : 'border'"
                icon="expand_more"
                icon-after
            >
              <span v-if="allChats || ticketsStatus === 'my_chats'">
                TODOS OS ATENDIMENTOS
              </span>
              <span v-if='ticketsStatus === "opened"'>
                ATENDIMENTOS ABERTOS
              </span>
              <span v-if='ticketsStatus === "closed"'>
                ATENDIMENTOS FECHADOS
              </span>
            </vs-button>

            <VsDropdownMenu>
              <VsDropdownItem @click.prevent="openOtherChats('opened')" @touchstart.prevent="openOtherChats('opened')">
                <span>ABERTOS</span>
              </VsDropdownItem>
              <VsDropdownItem @click.prevent="openOtherChats('closed')" @touchstart.prevent="openOtherChats('closed')">
                <span>FECHADOS</span>
              </VsDropdownItem>
              <VsDropdownItem @click.prevent="openOtherChats('all')" @touchstart.prevent="openOtherChats('all')">
                <span>TODOS</span>
              </VsDropdownItem>
            </VsDropdownMenu>
          </VsDropdown>

          <div v-if="chatTab !== 'my_chats' && chatTab !== 'inbox' && chatFilter !== 'campaign'">
            <div class="flex items-center justify-center" id="image-profile">
              <VsDropdown :vs-trigger-click="isSmallScreen">
                <vs-avatar size="40px" :src="attendantImage" :badge="contactDataLength" badge-color="#0491ff" style="font-size: 1.6em;" />
                <VsDropdownMenu>
                  <vs-dropdown-group vs-collapse vs-label="Selecione o atendente:" vs-icon="add">

                    <vs-input icon="search" placeholder="Search" v-model="searchUser" style="width:fit-content;" @input="getUsers()"/>
                    <p v-if="users.length === 0" class="pt-5 pb-2 pl-2">Nenhum usuário encontrado</p>
                    <vs-dropdown-group
                      v-else
                      style="
                          max-height: 20em;
                          overflow-y: auto;
                      "
                      vs-label="Atendentes:">
                        <VsDropdownItem
                          class="cursor-pointer"
                          v-for="contact in users"
                          :key="contact.id"
                          @click.prevent="getContactId(contact.id)"
                          @touchstart.prevent="getContactId(contact.id)"
                          >
                          <vs-list>
                            <vs-list-item :title="contact.name">
                              <template slot="avatar">
                                <vs-avatar :src=contact.image />
                              </template>
                            </vs-list-item>
                          </vs-list>
                        </VsDropdownItem>
                      </vs-dropdown-group>
                  </vs-dropdown-group>
                  <vs-button v-if="contactId" line-origin="center" style="margin-left: 20%;" color="danger" type="line">
                    <div v-if="state === 1">
                      <span @click="allClosed">
                        Limpar Filtro
                      </span>
                    </div>
                    <div v-if="state === 0">
                      <span @click="allOpened">
                        Limpar Filtro
                      </span>
                    </div>
                    <div v-if="state === null">
                      <span @click="allChatsFilter">
                        Limpar Filtro
                      </span>
                    </div>
                  </vs-button>
                </VsDropdownMenu>
              </VsDropdown>
            </div>
          </div>
        </div>

        <feather-icon
            class="md:inline-flex lg:hidden cursor-pointer"
            icon="XIcon"
            @click="toggleChatSidebar(false)"
        />
      </div>

      <status-checker @closeAlert="closeAlertStatusChecker"/>

      <div class="chat__profile-search flex px-4 mb-4">
        <div class="flex flex-row items-center justify-center w-full">
          <vx-tooltip v-if="chatTab !== 'all' && chatTab !== 'closed' && chatTab !== 'byAttendant' && showSelectList" text="Selecionar Todos" position="top" class="mt-2">
            <feather-icon class="fast mr-2" @click.stop="selectAllContacts=!selectAllContacts" :icon=" !selectAllContacts ? 'CheckCircleIcon' : 'XCircleIcon' " svgClasses="w-5 h-5 stroke-current" style="color: #0491ff; cursor: pointer;"/>
          </vx-tooltip>
          <vs-input
              icon-no-border
              icon="icon-search"
              icon-pack="feather"
              class="input-rounded-full"
              placeholder="Busque o nome ou número do contato"
              style="flex: 1"
              v-model="searchQuery"
              @change="searchBlank"
              @keydown.enter.prevent="onEnterSearch"
          />
          <vs-button
              @click="searchChats"
              icon="search"
              class="ml-3 py-2 px-5"
          />
          <vx-tooltip v-if="chatTab !== 'all' && chatTab !== 'closed' && chatTab !== 'byAttendant' && chatTab !== 'inbox'" text="Selecionar Atendimentos" position="top">
            <vs-button
              type="filled"
              icon="check_circle"
              class="ml-2"
              @click="showSelectList=!showSelectList"
            />
          </vx-tooltip>

          <vx-tooltip text="Iniciar Conversa" position="top">
            <vs-button
                type="flat"
                icon="chat"
                class="new-chat-button"
                @click="toggleNewChatSidebar"
            />
          </vx-tooltip>
        </div>

      </div>
      <div v-if="showSelectList" class="select-contacts" @click="validateSelectedList">
        <br>
        <p>Selecione a ação para os atendimentos</p>
      </div>

      <vs-divider class="d-theme-border-grey-light m-0" />
      <div style="height: 100% !important;" id="chats-list" class="vs-con-loading__container">
        <VuePerfectScrollbar
          class="chat-scroll-area chat-scroll-tickets"
          :settings="settings"
          :key="$vs.rtl"
          @ps-y-reach-end="scrollHandler"
          ref="chatScroll"
          :style="{
            'padding-bottom':`${paddingSelectedContacts}rem`,
            'height': !isOfficial && alertContact && alertStatusChecker && (dashBeta || typeConnection === 'tenancy.low-1') ? 'calc(100% - 24.2rem) !important' : 'calc(100% - 11.7rem) !important'
          }"
        >
          <!-- ACTIVE CHATS LIST -->
          <div class="chat__chats-list">
            <!-- <h3 class="text-primary mb-5 px-4">Atendimentos</h3> -->
            <ul ref="activeChatList" class="chat__active-chats bordered-items">
              <BulkTransferComponent
                :active="bulkTransferComponentIsActive"
                :contacts="selectedContacts"
                @isActiveFalse="bulkTransferComponentIsActive=false"
              />
              <li
                class="cursor-pointer"
                v-for="(contact, index) in contactData"
                :key="`chat-contact-${contact.id}-${contact.instance_id}`"
                @click="updateActiveChatUser(contact, true, index)"
              >
                <chat-contact
                  :contact="contact"
                  :last-message="contact.customerLastChat !== undefined ? contact.customerLastChat : []"
                  :unseenMsg="contact.unseenMsg"
                  :finishedTickets="finishedTickets"
                  :isActiveChatUser="activeChatUser && contact.id == activeChatUser.id"
                  :showSelectList="showSelectList"
                  :selectAllContacts="selectAllContacts"
                  :ticketsTransferring="transferring"
                  @onTransferringChat="onTransferringChat"
                  @onTransferredChat="onTransferredChat"
                  @contactSelected="handleSelectedContact"
                />
              </li>
              <li v-if="chatTab !== 'my_chats' && chatTab !== 'inbox' && chatFilter !== 'campaign' && contactData.length === 0" style="text-align: center;" class="text-primary mt-2 px-2">
                <vs-alert title="AVISO!" color="#E3B505" active="true" class="custom-alert">
                  <strong>{{ attendantName }}</strong> não tem atendimentos {{ stateName }} até o <strong>momento</strong>...
                </vs-alert>
              </li>
            </ul>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
    
    <!-- RIGHT COLUMN -->
    <div
        class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
        :class="{
        'sidebar-spacer--wide': clickNotClose,
        'flex items-center justify-center': activeChatUser === null,
      }"
    >

      <div class="centerx" v-show="loading">
        <div class="fill-row">
          <div
              id="loading-customer-chats"
              class="vs-con-loading__container"
              style="height: 100%;"
          ></div>
        </div>
      </div>
      <template v-if="activeChatUser">
        <div class="chat__navbar">
          <chat-navbar
            ref="chat-navbar"	
            :isSidebarCollapsed="!clickNotClose"	
            :finishedTickets="finishedTickets"	
            :chat-contact="activeChatUser"	
            @resetActiveChatUser="resetActiveChatUser"	
            @openContactsSidebar="toggleChatSidebar(true)"	
            @showProfileSidebar="showProfileSidebar"	
            @searchChats="searchChats"	
            @searchMessages="searchMessages"
            @searchDate="setDate"
          />
        </div>

        <div class="icon-container" :class="{ 'hidden-icon': !isDownBtnVisible }" :style="isFirefox ? 'right: 36px;' : ''"> 
          <vs-button 
            color="primary" 
            icon-pack="feather" 
            icon="icon-arrow-down" 
            class="shadow-lg btn-back-to-top"
            @click="setScrollDown()"
          />
          <span v-if="notificationCount > 0" class="notification-badge" :style="isFirefox ? 'right: 5.2em;' : ''">
            {{ notificationCount <= 99 ? notificationCount : '99+'}}
          </span>

        </div>
        <div style="border: solid 0.1px #c3c3c3; background-color: #EAF9F1;" v-if="connectionWeb && unifyConnections && alert && hasMultipleConnections && (dashBeta || typeConnection === 'tenancy.low-1')" @click="activeAlertPreview">
          <div class="mb-5 cursor-pointer" style="background-color: #EAF9F1; height: 80px;">
            <div style="margin: 8px; display: flex; align-items: center;">
              <div style="cursor: pointer;" class="absolute right-0 p-2" @click.prevent="closeAlert">
                <feather-icon icon='XIcon' svgClasses="h-6 w-6" />
              </div>
              <feather-icon style="margin-right: 10px;" class="text-success cursor-pointer " icon="AlertTriangleIcon"/>
              <strong style="margin: 5px;">Mantenha Seu WhatsApp Seguro com a Cloud</strong>
            </div>
            <div class="text ml-4">
              <p style="font-size: 12px;">Experimente a integração cloud oficial do WhatsApp e desfrute de benefícios como segurança aprimorada, proteção contra banimentos inesperados, conexão estável, suporte direto da Meta e maior eficiência no seu atendimento ao cliente. <strong><a style="color: #28C76F;">Clique aqui para saber mais.</a></strong></p>
            </div>
          </div>
        </div>
        <vs-popup ref="popup-satus-cropper" class="chat-upload-image-popup" title="Vantagens da API Cloud" :active.sync="activePopupAlert" @close="closePopupAlert()">
          <div class="w-full">
            <img :src="require('@/assets/images/brands/new_CTA_Cloud.gif')" class="w-full" style="border: 2px solid #CCCCCC;"/>
          </div>
          <strong style="font-size: 20px; margin-left: 10px; margin-top: 50px;">Entre em Contato Conosco</strong>
          <br>
          <ul style="list-style: none; padding: 0; display: flex; align-items: center; list-style-type: disc;  padding-left: 15px;">
            <li style="display: flex; align-items: center;">
              Vendas: (14) 99129-5361
              <a href="https://wa.me/5514991295361" target="_blank"><img style="cursor: pointer;" :src="require('@/assets/images/brands/whatsapp.png')" width="40" height="40"/></a>
            </li>
          </ul>
          <ul>
            <li style="padding-left: 15px;">
              Conheça mais sobre a API Cloud<a href="https://www.pedbot-faq.net/post/conhecendo-a-api-cloud" target="_blank"><strong> Click aqui</strong></a>
            </li>
          </ul>
        </vs-popup>
        <span @click.stop="closeStockImages">
          <expandable-image :active="openExpandImagePopUp" :src="expandImageSrc" @closeImage="openExpandImagePopUp = false"/>
          <chat-log
              ref="chat-log"
              v-if="activeChatUser"
              :finishedTickets="finishedTickets"
              :ticketsStatus="ticketsStatus"
              :contact-id="activeChatUser.customer.id"
              :instance-id="activeChatUser.instance_id"
              :contact-image="activeChatUser.customer.image"
              :contact-name="activeChatUser.customer.name"
              :new-chat="newChat"
              :messageSearch="messageSearch"
              :indexSearch="indexSearch"
              :lastNewMessage="lastNewMessage"
              :searchDate="searchDate"
              @openLoadingInDiv="openLoadingInDiv"
              @closeLoadingInDiv="closeLoadingInDiv"
              @updateMaxSearch="updateMaxSearch"
              @stopLoading="$vs.loading.close('#chat-app > .con-vs-loading')"
              @playAudioHowl="playAudioHowl"
              @pauseAudio="pauseAudio"
              :audioMap="audioMap"
              @resendAudio="resendAudio"
              @scrollToBottom="setScrollDown(1, true)"
              :style="{
                'height': connectionWeb && unifyConnections && alert && hasMultipleConnections && (dashBeta || typeConnection === 'tenancy.low-1') ? 'calc(100% - 20rem) !important' : ''
              }"
              @expandImagePopup="expandImagePopup"
          />
        </span>
        <div id="grid-stock" ref="grid-stock" v-show="showImagesStock" >
          <view-stock-images
              :images="imagesStock"
              @on-send-image="sendImage"
              @on-send-sticker="sendFile"
          ></view-stock-images>
        </div>
        <div v-if="chatReplyMessage" class="flex replyMessage">
          <div class="truncate flex">
            <div>Você responderá a mensagem: {{ replyMessageFormated | truncate(15) }}...</div>
            <div class="cursor-pointer" @click="clearReplyMessage">(Fechar)</div>
          </div>
        </div>

        <div class="chat__input flex p-4 bg-white" style="position: absolute; width: 100%; bottom: 0;">
          <div
              v-if="isTransferring(activeChatUser.id)"
              class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Atendimento em transferência</p>
          </div>
          <div
              v-else-if="chatTab !== 'my_chats'"
              class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Você pode enviar mensagem somente na aba "Meus atendimentos abertos"</p>
          </div>
          <div
              v-else-if="contactIsInInbox"
              class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Esse contato possui um atendimento aberto na caixa de entrada</p>
          </div>

          <div
              v-else-if="activeChatUser && activeChatUser.is_research"
              class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Você não pode enviar mensagem quando um atendimento esta aguardando uma avaliação</p>
          </div>

          <div
              v-else-if="isBeingAttendedByDifferentUser || contactIsBeingAttendedByDifferentUser"
              class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Esse contato já está sendo atendido</p>
          </div>
          <div
              v-else-if="activeChatUser.customer.has_valid_phone_number === false"
              class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Esse contato é invalido</p>
          </div>
          <div
            v-else-if="activeChatUser && activeChatUser.open_by_template"
            class="flex items-center justify-center disabled-textarea-wrapper"
          >
            <p>Atendimento aberto usando Modelo de Mensagens é necessário aguardar a resposta do contato.</p>
          </div>


          <div v-else-if="!newChat && !chatReplyMessage && !finishedTickets && !showImagesStock && ( showComment || !showTemplates)" id="comment-icon" class="absolute" style="z-index: 5 !important;">
            <vx-tooltip text="Modo de Comentários" position="top" :active="showCommentTooltip" @mouseover="showCommentTooltip = true" @mouseout="showCommentTooltip = false">
              <vs-switch v-model="commentActive" class="mb-1 ml-2 mr-2 mt-1">
                <span slot="on"><vs-icon iconPack="material-icons" icon="insert_comment" size="small" class="p-1"></vs-icon></span>
                <span slot="off"><vs-icon iconPack="material-icons" icon="speaker_notes_off" size="small" class="p-1"></vs-icon></span>
              </vs-switch>
            </vx-tooltip>
          </div>

          <div id="templates" v-show="showTemplates" ref="templates">
            <ul id="templates-box" ref="templates-box">
              <li
                  :ref="'li' + i"
                  class="template-item"
                  :class="{ 'is-active': i === arrowCounter }"
                  v-bind:key="template.id" v-for="(template, i) in templates"
                  @click="selectMessage(template, true)"
              >
                <div class="icon"><feather-icon class="fast" icon="FastForwardIcon" svgClasses="w-5 h-5 stroke-current"/></div>
                <div>{{ template.identifier }}</div>
              </li>
            </ul>
          </div>

          <div
              class="chat-record-audio pr-5 mt-4 justify-center"
          >
          <div v-if="isSmallScreen" class="select-container">
              <VsDropdown vs-trigger-click>
                <vs-button radius icon="add" class="pl-3 ml-4" type="filled" style="margin-top: 8px; margin-left: 0;"></vs-button>

                <VsDropdownMenu>
                  <VsDropdownItem @click.prevent="openStockImages" @touchstart.prevent="openStockImages">
                    <feather-icon icon="ImageIcon" svgClasses="h-8 w-8" class="ml-4" style="cursor: pointer; margin-right: 5px;"/>
                    Adicionar imagem
                  </VsDropdownItem>
                  <VsDropdownItem @click.prevent="openImageModal" @touchstart.prevent="openImageModal">
                    <feather-icon icon="PaperclipIcon" svgClasses="h-8 w-8" class="ml-4" style="cursor: pointer; margin-right: 5px;"/>
                    Adicionar arquivo
                  </VsDropdownItem>
                </VsDropdownMenu>
              </VsDropdown>
            </div>
            <span v-else>
              <VsDropdown v-if="!chatReplyMessage" vs-collapse vs-trigger-click style="cursor: pointer">
                <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-8 w-8 mt-3"
                    class="ml-4"
                    style="cursor: pointer"
                    @click.prevent="openStockImages"
                />
                <VsDropdownMenu>
                  <VsDropdownItem @click.prevent="openImageModal" @touchstart.prevent="openImageModal">
                    <feather-icon icon="FileIcon" svgClasses="h-8 w-8" style="color: #007bfc; transform: translateX(-4em)"></feather-icon>
                    <span style="transform: translateX(-3.3em)">Arquivos</span>
                  </VsDropdownItem>
                  <VsDropdownItem @click.prevent="openStockImages" @touchstart.prevent="openStockImages">
                    <feather-icon icon="ImageIcon" svgClasses="h-8 w-8" style="color: #02a698; transform: translateX(-1em)"></feather-icon>
                    <span style="transform: translateX(-0.3em)">Imagem e Figurinha</span>
                  </VsDropdownItem>
                </VsDropdownMenu>
              </VsDropdown>

              <VsDropdown vs-collapse vs-trigger-click style="cursor: pointer">
                <feather-icon
                    icon="SmileIcon"
                    svgClasses="h-8 w-8 mt-3"
                    class="btn-drop ml-4 cursor-pointer"
                />

                <VsDropdownMenu>
                  <div>
                    <picker 
                      title=""
                      set="apple"
                      color="#42acff"
                      emoji="raised_hand"
                      locale="br"
                      :perLine="11"
                      @select="selectEmoji"
                      :i18n="i18n"
                      :infiniteScroll=false
                    />
                  </div>
                </VsDropdownMenu>
              </VsDropdown>
            </span>
          </div>
          <textarea
            class="flex-1 message-textarea"
            :placeholder="!commentActive ? 'Escreva sua mensagem...' : 'Escreva seu comentário...'"
            v-model="typedMessage"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.delete="onBackspace"
            @keydown.enter.prevent="onEnter"
            @keydown="messageInputHandler"
            :disabled="finishedTickets"
            @paste="YourPaste"
            ref="textArea"
            :class="{ 'textarea-ios': isIos, 'textarea-android': isAndroid }"
          /> 

          <div
              class="chat-record-audio flex pl-5 mt-4"
              v-if="audioGridActive"
          >
            <vs-button
                type="filled"
                color="danger"
                @click.prevent="cancelAudio"
            >
              <feather-icon
                  icon="XCircleIcon"
                  style="cursor: pointer;"
              />
            </vs-button>

            <span class="ml-2 mr-2">{{ formattedTime }}</span>

            <vs-button
                type="filled"
                color="success"
                @click.prevent="sendAudio"
            >
              <feather-icon
                  icon="CheckCircleIcon"
                  style="cursor: pointer;"
              />
            </vs-button>
          </div>
          <feather-icon
              icon="MicIcon"
              svgClasses="h-8 w-8"
              class="ml-4"
              style="cursor: pointer; margin-left: 10px;"
              v-if="!audioGridActive && !chatReplyMessage && !commentActive && isSmallScreen"
              @click.prevent="recordAudio"
          />

          <feather-icon
              icon="MicIcon"
              svgClasses="h-8 w-8"
              class="ml-4"
              style="cursor: pointer;"
              v-if="!audioGridActive && !commentActive && !isSmallScreen"
              @click.prevent="recordAudio"
          />
          <vs-button 
              v-if="isSmallScreen" 
              style="margin-top: 20px;"
              radius icon="send" 
              class="pl-3 ml-4"
              type="filled"
              :disabled="finishedTickets"
              :color="!commentActive ? 'primary' : 'warning'"
              :class="!commentActive ? 'bg-primary-gradient' : 'bg-warning-gradient'"
              @click="!commentActive ? sendMsg() : sendComment()"></vs-button>
          <vs-button
              v-else
              class="pl-5 ml-4"
              type="filled"
              :disabled="finishedTickets"
              :color="!commentActive ? 'primary' : 'warning'"
              :class="!commentActive ? 'bg-primary-gradient' : 'bg-warning-gradient'"
              @click="!commentActive ? sendMsg() : sendComment()"
          >
            Enviar
          </vs-button>
        </div>


      </template>
      <template v-else>
        <div class="flex flex-col items-center">
          <feather-icon
              icon="MessageSquareIcon"
              class="mb-4 bg-white p-8 shadow-md rounded-full"
              svgClasses="w-16 h-16"
          />
          <h4
              class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
              @click.stop="toggleChatSidebar(true)"
          >
            Iniciar Atendimento
          </h4>
        </div>
      </template>
    </div>

    <vs-popup
        class="chat-audio-not-allowed-popup"
        title="Permitir microfone"
        :active.sync="audioNotAllowedPopupActive"
    >
      <p>
        Para gravar mensagens de voz, o WhatsApp precisa ter acesso ao microfone de seu computador.
        Clique em <img class="firefox-lock-icon" src="https://pedbot.s3.amazonaws.com/whatsapp/firefox-lock-icon.png">
        na barra de endereços e ajuste “Usar o microfone” para “Permitir”.
      </p>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
            class="mr-4 mt-4 sm:mb-0 mb-2"
            type="filled"
            color="rgb(62, 201, 214)"
            @click.prevent="audioNotAllowedPopupActive = false"
        >
          OK, ENTENDI.
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup
        class="chat-audio-not-found-popup"
        title="Microfone não encontrado"
        :active.sync="audioNotFoundPopupActive"
    >
      <p>
        Você não pode gravar uma mensagem de voz porque parece que seu computador não tem um microfone.
        Tente conectar um microfone ou caso já o tenha conectado, reinicie seu navegador.
      </p>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
            class="mr-4 mt-4 sm:mb-0 mb-2"
            type="filled"
            color="rgb(62, 201, 214)"
            @click.prevent="audioNotFoundPopupActive = false"
        >
          OK, ENTENDI.
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup
        :class="{ 'upload-image-popup' : imageUrl.length > 0 }"
        title="Enviar Anexo"
        :active.sync="popupActive"
        @close="closeImageModal"
    >
      <div v-if="newChat" class="d-flex items-center text-center" >
        <vs-alert active="true" color="warning" class="no-message-alert mb-4" >
          Somente é possível anexar um arquivo ao iniciar um novo atendimento.
        </vs-alert>
      </div>
      <div class="d-flex items-center justify-center">
        <upload
            :action="uploadApiUrl"
            fileName="file"
            :headers="{ Authorization: 'Bearer ' + bearer }"
            text="Selecionar Anexo"
            automatic
            :limit="newChat ? 1 : 10"
            :multiple="true"
            :single-upload="true"
            @on-success="successUploadImage"
            @change-caption="watchImageCaption"
            @on-error="errorUploadImage"
            @on-delete="deleteUploadImage"
            ref="uploadComponent"
            class="chat-upload-image-popup"
          />
      </div>
      <div class="d-flex items-center justify-center">
        <vs-button
            class="ml-2 mt-4 sm:mb-0 mb-2"
            type="filled"
            color="rgb(62, 201, 214)"
            :disabled="imageUrl.length === 0"
            @click.prevent="sendImage"
        >
          Enviar Anexo
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup
        class="chat-refuse-attendance-popup"
        title="Transferência de atendimento recusada"
        :active.sync="refuseAttendancePopupActive"
        v-if="ticketTransfer"
    >
      <vs-row class="mt-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span>
            O atendente
            <span color="text-primary">{{ ticketTransfer.previous_user_name }}</span>
             recusou a transferência de atendimento do cliente
            <span color="text-primary">
              {{ ticketTransfer.customer_name }} {{ ticketTransfer.customer_phone_number }}.
            </span>
          </span>
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup class="chat-refuse-attendance-popup" title="Atenção" :active.sync="popupReactivateChat" v-on:close="popupReactivateChat = false">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mb-5 text-center">
        <p>Atendimento está aberto a mais de <b>24 horas</b>, por esse motivo é necessário encaminhar novamente o modelo de mensagem ou encerrá-lo.</p>
      </vs-col>

      <footer>
        <div class="w-full d-flex" style="justify-content: center">
          <vs-button
              class="mr-2"
              color="primary"
              icon-pack="feather"
              icon="icon-x-circle"
              @click.prevent="closeChat"
          >
            <span>Encerrar Atendimento</span>
          </vs-button>

          <vs-button
              class="mr-2"
              color="primary"
              icon-pack="feather"
              icon="icon-message-circle"
              @click.prevent="openMetaMessage"
          >
            <span>Encaminhar Modelo</span>
          </vs-button>
        </div>
      </footer>
    </vs-popup>

    <contact-dropdown></contact-dropdown>
    <inbox-contact-picker></inbox-contact-picker>
    <finalize-popup @resetActiveChatUser="resetActiveChatUser"></finalize-popup>
    <transfer-ticket-popup @searchChats="searchChats"></transfer-ticket-popup>
    <customers-list-forward :isActive="showCustomersList" @isActiveFalse="showCustomersList=false" :customerChat="customerChatForwarded"></customers-list-forward>
  </div>
</template>

<script>

import {
  isUrl,
  hasFeature,
  formatDate,
  generateHash,
  encodeToBase64,
  instanceObject,
  getCurrentTenant,
  populateQuerySum,
  formatRouteTenantPath
} from "@/utils";

import axios from 'axios';
import moment from "moment/moment";
import ChatLog from "./ChatLog.vue";
import NewChat from "./NewChat.vue";
import { Picker } from 'emoji-mart-vue';
import ChatNavbar from "./ChatNavbar.vue";
import ChatContact from "./ChatContact.vue";
import UserProfile from "./UserProfile.vue";
import InboxButton from './InboxButton.vue';
import { connect } from "@/websockets/client";
import Users from "@/http/requests/user/index";
import StatusChecker from './StatusChecker.vue';

import Upload from '@/components/upload/Upload';
import FinalizePopup from './FinalizePopup.vue';
import GetOrderByMsg from "./GetOrderByMsg.vue";
import customerApi from '@/http/requests/customer';
import ContactDropdown from "./ContactDropdown.vue";
import Button from '@/components/button/Button.vue';
import chatContact from "@/http/requests/chatContact";
import VueCountdown from '@chenfengyuan/vue-countdown';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import InboxContactPicker from './InboxContactPicker.vue';
import TransferTicketPopup from './TransferTicketPopup.vue';

import { ChatTicketService } from "@/db/chatTicket_service";
import { OrderByMsgService } from "@/db/orderByMsg_service";
import moduleSettings from '@/store/settings/moduleSettings';
import moduleCustomer from '@/store/customer/moduleCustomer';
import CustomerChat from "@/http/requests/customerChats/index";
import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
import { CustomerChatService } from "@/db/customerChat_service";
import BulkTransferComponent from "./BulkTransferComponent.vue";
import {CustomerGroupService} from "@/db/customerGroup_service";

import moduleStockImages from '@/store/stockImages/moduleStockImages';
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
import InstancesSlimList from "@/views/instances/InstancesSlimList.vue";
import moduleChatSettings from '@/store/chatSettings/moduleChatSettings';
import ViewStockImages from '@/components/stock-image-card/ViewStockImages.vue';
import moduleMessageTemplate from '@/store/messageTemplates/moduleMessageTemplate';
import CustomerCategorySlimList from "@/views/customer-groups/CustomerCategorySlimList.vue";
import ExpandableImage from '@/components/ExpandableImage.vue';
import { dashBetas } from '@/supports/betaNotificationSupport';
import CustomersListForward from "@/views/customers/CustomersListForward.vue";

const i18n = {
  search: 'Buscar',
  notfound: 'Nenhum resultado encontrado',
  categories: { 
    search: 'Resultados de pesquisa', 
    recent: 'Usados frequentemente',
    people: 'Smileys e Pessoas',
    nature: 'Animais e Natureza',
    foods: 'Comidas e Bebidas',
    activity: 'Atividades',
    places: 'Viagens e lugares',
    objects: 'Objetos',
    symbols: 'Símbolos',
    flags: 'Bandeiras',
  },
}

export default {
  name: "chat-attendance",
  data() {
    return {
      alertStatusChecker: true,
      typeConnection: '',
      i18n: i18n,
      alert: true,
      dashBeta: false,
      activePopupAlert: false,
      isOfficial: false,
      alertContact: true,
      uploadComplete: false,
      research: [],
      filterGroups: [],
      filterInstances: [],
      arrowCounter: 0,
      contactId: null,
      selectContact: null,
      state: null,
      orders: [],
      whichChat: [],
      amountCash: 0,
      addNewDataSidebar: false,
      stateName: '',
      attendantName: '',
      attendantImage: '',
      templates: [],
      showImagesStock: false,
      usingTemplate: false,
      showTemplates: false,
      replyMessageId: null,
      searchingForMessages: false,
      existsOldMessages: true,
      popupActive: false,
      popupReactivateChat: false,
      audioNotAllowedPopupActive: false,
      audioNotFoundPopupActive: false,
      audioGridActive: false,
      mediaRecorder: null,
      audioChunks: [],
      audioResend: [],
      canSendAudio: false,
      audioSeconds: 0,
      refreshIntervalId: null,
      imageUrl: [],
      fileName: null,
      finishedTickets: false,
      countImageSent: 0,
      clickNotClose: true,
      isChatSidebarActive: true,
      active: true,
      isHidden: false,
      searchContact: "",
      activeProfileSidebar: false,
      activeChatUser: null,
      profileObject: null,
      typedMessage: "",
      isChatPinned: false,
      transferring: [],
      showSelectList: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7,
      },
      isLoggedInUserProfileView: false,
      searchQuery: "",
      isSendingMessage: false,
      activeNewChatSidebar: false,
      transferredChatsPopup: false,
      ticketsStatus: 'my_chats',
      searchingForCustomers: false,
      currentPage: 1,
      limitPerPage: 10,
      lastPage: false,
      ticketTransfer: null,
      ticketTransferPopup: false,
      refuseAttendancePopupActive: false,
      timer: 0,
      searchMessage: "",
      loading: false,
      limit: 10,
      makeScroll: false,
      contactData: null,
      contactDataLength: 0,
      users: [],
      showInbox: false,
      queryValues: [{
        instance_id: 1,
        finished_ticket: 0,
        inbox: 1,
        user_id: 0,
        allUsers: 1
      }],
      scroll: false,
      ccService: null,
      ccServiceOrderByMsg: null,
      ctService: null,
      cgService: null,
      myChatsSum: 0,
      countLoop: 0,
      refreshTable: false,
      newChat: false,
      oldHeight: 0,
      textSearch: null,
      groupsFilter: null,
      oldestFirst: false,
      oldestPriority: false,
      baseLimit: 10,
      commentActive: false,
      showComment: false,
      messageSearch: '',
      indexSearch: 0,
      hasErpFeature: false,
      hasCatalogFeature: false,
      lastNewMessage: '',
      audioMap: {},
      showCommentTooltip: false,
      isSmallScreen: false,
      searchUser: '',
      bulkTransferComponentIsActive: false,
      paddingSelectedContacts: 2.2,
      selectedContacts: [],
      selectAllContacts: false,
      oldValueChatTab: '',
      isDownBtnVisible: true,
      notificationCount: 0,
      currentContactIndex: null,
      scrollStatus: {
        handleCreated: false,
        scrolled: 0
      },
      searchCount: 0,
      firstTime: false,
      inboxSum: 0,
      otherChatsOpened: false,
      openExpandImagePopUp: false,
      expandImageSrc: '',
      mediaInfo: [],
      searchDate: '',
      showCustomersList: false,
      customerChatForwarded: {},
    };
  },
  watch: {
    addNewDataSidebar(hidden) {
      if (hidden) {
        this.$events.fire('SetButtonFloating', true);
      } else {
        this.$events.fire('SetButtonFloating', false);
      }
    },
    showSelectList(val) {
      val ? this.paddingSelectedContacts = 5.5 : this.paddingSelectedContacts = 2.2;

      if (!val) {
        this.selectAllContacts = false;
      }
    },
    typedMessage(val) {
      if (!val) {
        return
      }

      this.showImagesStock = false
      if (this.checkTemplatePartial(val)){
        this.showTemplates = true
        return
      }

      this.showTemplates = false
    },
    windowWidth() {
      this.setSidebarWidth();
    },
    async chatTab(newValue, oldValue) {
      this.oldValueChatTab = oldValue;
      this.showSelectList  = false;
      this.fetchContactsData();
    },
    async contactId() {
      await this.fetchContactsData(true);
    },
    isChatSidebarActive(value){
      if (!value) {
        setTimeout(() => {
          if (!this.isChatSidebarActive) this.setSidebarWidth();
        }, 100)
      }
    },
    chatContacts() {
      this.$forceUpdate;
    },
    "$store.state.chatContact.selectedCustomerChats.customerId"(val) {
      this.currentPage = 1;
      this.cancelAudio();
      if (val === null) {
        this.resetActiveChatUser();
      }
      this.clearReplyMessage()
    },
    async "$store.state.chatContact.chatTab"(val) {
      this.$refs.chatScroll.$el.scrollTop = 0;
      this.searchingForCustomers = false
      this.currentPage = 1;
      this.limit = 10;
      this.searchQuery = '';
      this.resetActiveChatUser();
      await this.queryObservable(val, true);

      if (this.chatFilter === 'unseenMsg') {
        this.searchMore()
      }
      
    },
    async "$store.state.chatContact.chatFilter" (val) {
      this.searchingForCustomers = false
      this.currentPage = 1;
      this.limit = 10;
      this.searchQuery = '';
      this.resetActiveChatUser();
      await this.queryObservable();

      if (val === 'unseenMsg') {
        if (this.additionalChatFilter === 'search') {
          this.additionalChatFilter = null;
          this.$vs.notify({
            color: 'warning',
            title: 'Atenção',
            text: `O filtro "Pesquisa NPS" é desativado caso o filtro "Mensagens não lidas" seja selecionado.`,
            time: 6000
          });
        }
        this.searchMore()
      }
      this.filterMyChatsSum();

    },
    "$store.state.chatContact.additionalChatFilter"() {
      this.searchingForCustomers = false
      this.currentPage = 1;
      this.limit = 10;
      this.searchQuery = '';
      this.resetActiveChatUser();
      this.queryObservable();
      this.filterMyChatsSum();
    },
    transferredChatsPopup(val) {
      if (!val) {
        this.$store.dispatch("chatContact/clearTransferredChats")
      }
    },
    transferredChats(val) {
      if (val.length) {
        this.transferredChatsPopup = true
      }
    },
    "$store.state.chat.chatReplyMessage"(val) {
      if (val){
        this.commentActive = false
        this.showImagesStock = false
      }
    },
    templates(val){
      if (val.length > 0) {
        this.showComment = false;
      } else {
        this.showComment = true;
      }
    },
    '$store.state.chatSettings.sumOfTickets': {
      handler: 'filterMyChatsSum',
      immediate: false,
      deep: true
    },
  },
  computed: {
    sumToCheck() {
      return this.$store.state.chatContact.chatTab === 'my_chats' ? this.myChatsSum : this.inboxSum
    },
    countContactData() {
      return this.contactData ? this.contactData.length : 0
    },
    hasMultipleConnections() {
      const connections = this.$store.state.instance.chosenInstances;
      return connections.length > 1;
    },
    isIos() {
      return window.innerWidth <= 430 && window.innerHeight <= 932;
    },
    isFirefox() {
      if (navigator.userAgent.indexOf("Firefox") != -1) {
        return true;
      }
      return false;
    },
    isAndroid() {
      return window.innerWidth <= 393 && window.innerHeight <= 873;
    },
    chatReplyMessage() {
      return this.$store.state.chat
          ? this.$store.state.chat.chatReplyMessage
          : null;
    },
    messageTemplates() {
      return this.$store.state.messageTemplates.templates
    },
    imagesStock() {
      return this.$store.state.stockImages
          ? JSON.parse(JSON.stringify(this.$store.state.stockImages.stockImages)).sort((a, b) => b.id - a.id)
          : [];
    },
    transferredChats() {
      return this.$store.state.chatContact
          ? this.$store.state.chatContact.transferredChats
          : [];
    },
    activeInstance() {
      return this.$store.state.activeInstance ? `Atendimento - ${this.$store.state.activeInstance}`:'';
    },
    bearer() {
      return this.$store.state.auth.bearer;
    },
    uploadApiUrl() {
      return localStorage.getItem("baseUrl") + "/api/file/upload";
    },
    chatContacts() {
      return this.$store.state.chatContact
          ? this.$store.state.chatContact.chatContacts
          : [];
    },
    activeUser() {
      return this.$store.state.AppActiveUser;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    unifyConnections() {
      return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
    },
    isBeingAttendedByDifferentUser() {
      if (!this.activeChatUser) {
        return false;
      }

      if (this.activeUser.role) {
        if (this.activeUser.role.name === "administrador") {
          return false;
        }
      }

      return this.contactIsBeingAttendedByDifferentUser
    },
    contactIsBeingAttendedByDifferentUser() {
      const isBeingAttendedBy =  this.activeChatUser.customer.isBeingAttendedBy || null;

      if (isBeingAttendedBy && isBeingAttendedBy.length > 0) {
        return isBeingAttendedBy.some(attendant => (
            attendant.user_id !== this.activeUser.id &&
            attendant.instance_id === this.activeChatUser.instance_id &&
            this.$store.getters["instance/chosenInstanceIds"].includes(attendant.instance_id)
        ));
      }

      return false
    },
    contactIsInInbox() {
      const isBeingAttendedBy =  this.activeChatUser.customer.isBeingAttendedBy || null;

      if (isBeingAttendedBy && isBeingAttendedBy.length > 0){
        return isBeingAttendedBy.some(attendant => (
            attendant.user_id === null &&
            attendant.instance_id === this.activeChatUser.instance_id &&
            this.$store.getters["instance/chosenInstanceIds"].includes(attendant.instance_id)
        ));
      }

      return false;
    },
    formattedTime(){
      var totalSeconds = parseInt(this.audioSeconds, 10);
      let hours = 0;
      if (totalSeconds>=3600){
        hours   = Math.floor(totalSeconds / 3600);
        hours = hours < 10 ? "0"+hours : hours;
      }else{
        hours = 0;
      }

      var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
      var seconds = totalSeconds - (hours * 3600) - (minutes * 60);

      minutes = minutes < 10 ? "0"+minutes : minutes;
      seconds = seconds < 10 ? "0"+seconds : seconds;

      if(totalSeconds>=3600){
        return hours+':'+minutes+':'+seconds;
      }
      return minutes+':'+seconds;
    },
    chatTab() {
      return this.$store.state.chatContact.chatTab;
    },
    chatFilter:{
      get(){
        return this.$store.state.chatContact.chatFilter;
      },set() {}
    },
    additionalChatFilter:{
      get(){
        return this.$store.state.chatContact.additionalChatFilter;
      },set(value) {
        this.setAdditionalChatOrigin(value)
      }
    },
    hasGroupFilter(){
      return this.$store.getters["chatContact/groupsSelectedFilter"].length > 0
    },
    otherChatsShouldBeFilled() {
      return ['my_chats', 'inbox'].indexOf(this.chatTab) === -1;
    },
    chatsBeFilled() {
      return (
          ['campaign', 'attendance', 'maria', 'unseenMsg'].indexOf(this.chatFilter) !== -1 ||
          this.hasGroupFilter
      );
    },
    allChats() {
      return ['all', 'inbox'].indexOf(this.ticketsStatus) !== -1;
    },
    replyMessageFormated(){
      if (this.chatReplyMessage.tag_type === "contact"){
        try {
          const messageDecode = JSON.parse(this.chatReplyMessage.message);
          return messageDecode.name
        } catch (error) { return 'Contato' }
      }
      else if ( this.chatReplyMessage.document_name && (
          this.chatReplyMessage.tag_type === "document" || this.chatReplyMessage.tag_type === "image"
      )){
        return this.chatReplyMessage.document_name
      }
      else if (this.chatReplyMessage.tag_type === "location"){
        return 'Localização'
      }
      else if (this.chatReplyMessage.tag_type === "audio"){
        return 'Audio'
      }
      else if (this.chatReplyMessage.tag_type === "sticker"){
        return 'Figurinha'
      }
      else if (this.chatReplyMessage.tag_type === "payment"){
        return 'Pagamento'
      }
      else if (this.chatReplyMessage.tag_type === "order"){
        return 'Pedido'
      }

      return this.chatReplyMessage.message
    },
    chatLogScroll() {
      return this.$refs['chat-log'].$refs['chatContainer'];
    },
    connectionWeb(){
      if ( this.activeChatUser && this.activeChatUser.instance_id ){
        const instanceObj = instanceObject(this.activeChatUser.instance_id);
        return instanceObj && !instanceObj.is_official;
      }

      return true;
    }
  },
  methods: {
    instanceObject,
    async searchMore() {
      
      if (this.countContactData === this.sumToCheck || (this.countContactData >= 10 && this.firstTime)) {
        this.searchCount = 0;
        this.scroll = false;
        return;
      }
      this.firstTime = true;
      this.scroll = true;
      this.searchCount++
      this.currentPage = this.searchCount
      await this.observerTicketData()

      setTimeout(() => {
        this.searchMore();
      }, 3500)
    },
    expandImagePopup(imageSrc) {
      this.openExpandImagePopUp = true
      this.expandImageSrc = imageSrc;
    },
    updateInboxChatSum(sum) {
      this.inboxSum =  sum
    },
    customNotifyUnseenMsgFilter() {
      this.additionalChatFilter = !this.additionalChatFilter;
      this.notifyUnseenMsgFilter();
    },
    notifyUnseenMsgFilter() {
      if (this.chatFilter !== 'unseenMsg') { return; }
      return this.$vs.notify({
        color: 'warning',
        title: 'Atenção',
        text: `Não é possível adicionar a Pesquisa NPS com o filtro de "Mensagens não lidas" selecionado.`,
        time: 6000
      });
    },
    showWithdrawal(address) {
      if (address) {
        const formatedAddress = JSON.parse(address);
        if (formatedAddress.address === 'none') {
            return false;
        }
      }
      return true;
    },
    setOpenCustomersList(show) {
      this.showCustomersList = show;
    },
    closeAlert(){
      this.alert = false
    },
    closeAlertStatusChecker(){
      this.alertStatusChecker = false;
    },
    closePopupAlert(){
      this.activePopupAlert = false;
    },
    activeAlertPreview(){
      this.activePopupAlert = true
    },
    handleEnterKey(event) {
      if (this.popupActive && this.uploadComplete && event.key === 'Enter') {
        this.sendImage();
      }
    },
    validateSelectedList() {
      if (this.chatTab === 'all' || this.chatTab === 'closed') {
        return this.$vs.notify(
          {
            color: 'warning',
            title: 'Aviso!',
            text: 'Não é possível selecionar atendimentos utilizando esse filtro!'
          }
        );
      }

      if (this.selectedContacts.length === 0) {
        return this.$vs.notify(
          {
            color: 'warning',
            title: 'Aviso!',
            text: 'Você deve selecionar pelo menos um contato para realizar a ação desejada!'
          }
        );
      }

      this.bulkTransferComponentIsActive = true;
    },
    checkScreenWidth() {
      this.isSmallScreen = window.innerWidth <= 500;
    },
    isIphoneIos() {
      const isIphoneIos = /iPhone|iPad|iPod|Mobile Safari|safari/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent);
      if(isIphoneIos){
        return true;
      }
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    sendOrderAccepted(message) {
      this.typedMessage = message;
      this.sendMsg();
    },
    sendOrderRejected(message) {
      this.typedMessage = message;
      this.sendMsg();
    },
    async getUsers() {
      await Users.fetch(this.searchUser).then((users) => {
        let usersData = users.data.data.users;
        this.users = usersData.sort((first, last) => first.name.localeCompare(last.name));
      })
    },
    selectEmoji(emoji) {
      this.typedMessage += emoji.native;
    },
    returnCash(value) {
      return (value / 1000).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    async getNameUsers(userId) {
      const response = await Users.fetch();
      const users = response.data.data.users;
      const user = users.find(user => user.id === userId);
      
      if (user) {
        this.attendantName = user.name;
        this.attendantImage = user.image;
      } else {
        this.attendantName = 'Este usuário';
        this.attendantImage = 'https://cdn.onlinewebfonts.com/svg/img_131793.png';  
      }
    },
    allChatsFilter() {
      this.contactId = null
      this.openOtherChats('all')
      this.queryObservable();
    },
    allOpened() {
      this.contactId = null
      this.openOtherChats('opened')
      this.queryObservable();
    },
    allClosed() {
      this.contactId = null
      this.openOtherChats('closed')
      this.queryObservable();
    },
    getContactId(data) {
      this.contactId = data
      this.getNameUsers(data);

      if (this.state === null) {
        this.state = null
      } else {
        this.state = this.state ? 1 : 0
      }

      if (this.state === 1) {
        this.stateName = 'fechados'
      } else if (this.state === 0) {
        this.stateName = 'abertos'
      } else {
        this.stateName = ''
      }

      this.openOtherChats('byAttendant')
      this.queryObservable();
    },
    formatServieDate(dateParam) {
      const data = new Date(dateParam);
      const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const timeOptions = { hour: '2-digit', minute: '2-digit' };

      const dateStr = data.toLocaleDateString('pt-BR', dateOptions);
      const timeStr = data.toLocaleTimeString('pt-BR', timeOptions);

      return { date: dateStr, time: timeStr };
    },
    prePreOrderMessageTemplate(data) {
      if (data.hasService === undefined) {
        data.hasService = data.services.length > 0;
      }
      if (data.hasProduct === undefined) {
        data.hasProduct = data.orderProducts.length > 0;
      }

      let text = `*Confirme os Dados do seu Pedido Nº `+ data.id +`:*\n\n` +
      `*_Lista de ${data.hasProduct && data.hasService ? 'Produtos e Serviços' : (data.hasProduct ? 'Produtos' : 'Serviços')} do Pedido:_*\n`;

      if (data.hasProduct) {
        const product = (data.postSentMessage !== undefined && data.postSentMessage === true)
          ? data.orderProducts : JSON.parse(data.product);

        let count = 1;
        product.forEach((item) => {
          if (data.postSentMessage !== undefined && data.postSentMessage === true) {
            item = {...item, ...item.product}
          }
          if (item.integration_id !== null && item.quantity <= 0 && this.hasErpFeature) {
            text += `${count}. ` + item.name.toUpperCase() + '\n- Infelizmente, não possuímos esse produto em estoque\n';
          } else {
            text += `${count}. ` + item.name.toUpperCase()+ '\n- Valor total: R$ ' + String(parseFloat(item.price * item.quantity).toFixed(2)).replace('.', ',') +  ' - Com desconto: R$ ' + String(parseFloat(item.discount_price * item.quantity).toFixed(2)).replace('.', ',') + '\n- Quantidade: ' + item.quantity + (item.quantity == 1 ? ' unidade\n' : ' unidades\n');
            text += `- Valor unitário: R$ ${String(parseFloat(item.price).toFixed(2)).replace('.', ',')}\n`;
          }
          ++count;
        })
      }
      
      if (data.hasService) {
        const services = data.service ? data.service : data.services;
        services.forEach(item => {
          if (item.scheduled_at) {
            item.date = this.formatServieDate(item.scheduled_at).date
            item.time = this.formatServieDate(item.scheduled_at).time
          }
          const discountPriceNumeric = parseFloat(item.discount_price);
          text += item.name + ' | preço original R$  ' + String(parseFloat(item.price).toFixed(2)).replace('.', ',') + ' | R$ ' + String(parseFloat(discountPriceNumeric).toFixed(2)).replace('.', ',') + ' com desconto '  + ' | agendado para o dia ' + item.date + ' às ' + item.time + '\n';
        });
      }

      if (data.hasProduct) {
        if (data.is_delivery) {
          const address = (data.postSentMessage !== undefined && data.postSentMessage === true)
              ? JSON.parse(data.address) : JSON.parse(data.address);

          text += '\n*_Informações de Entrega:_*\n' + 'Valor da entrega: R$ ' + String((parseFloat(address.delivery_fee)).toFixed(2)).replace('.', ',') + '\n';
          text += address.address + '\n';
          text += 'CEP: ' + address.cep + '\n';
          text += 'Nº: ' + address.number + '\n';
          address.complement ? text += 'Complemeto: ' + address.complement + '\n' : '';
        } else if (this.showWithdrawal(data.address)) {
            text += '\n*Pedido para Retirada*\n';
        }
      }

      const payment_data = (data.postSentMessage !== undefined && data.postSentMessage === true)
        ? (typeof data.payment_data === 'string' ? JSON.parse(data.payment_data) : data.payment_data)
        : JSON.parse(data.payment_data);

      if (payment_data.type !== 'none') {

        text += '\n*_Informações de Pagamento:_*\n';
        text += 'Forma de pagamento: ' + (payment_data.type === 'card' ? payment_data.paymentModality === 'credit' ? 'Cartão Crédito' : 'Cartão Débito'  : (payment_data.type === 'cash' ? 'Dinheiro' : 'Pix')) + '\n';
        
        if (payment_data.type === 'card' && payment_data.paymentModality === 'credit') {
          text += 'Parcelado em ' + payment_data.months + 'x de R$ ' + String((parseFloat(data.purchase_value / payment_data.months)).toFixed(2)).replace('.', ',') + '\n';
        }
        if (payment_data.type === 'cash' && payment_data.money_change != 0) {
          text += 'Troco para R$ ' + String(parseFloat(payment_data.money_change).toFixed(2)).replace('.', ',') + '\n';
        }
      }

      text += '\n*_Valor Total da Compra:_*\n';
      text += 'R$ ' + String((parseFloat(data.purchase_value)).toFixed(2)).replace('.', ',');

      this.typedMessage = text;
    },
    openLoadingInDiv() {
      this.loading = true
      this.$vs.loading({
        container: `#loading-customer-chats`,
        text: 'Estamos carregando todo o histórico do cliente, aguarde um momento...',
        scale: 0.6,
      })
    },
    closeLoadingInDiv() {
      this.loading = false
      this.$vs.loading.close('#loading-customer-chats > .con-vs-loading')
    },
    onBackspace() {
      this.showTemplates = false
    },
    onArrowDown(event){
      if (!this.showTemplates){
        return;
      }

      event.preventDefault();
      this.$refs[`templates`].scrollTop += this.$refs[`li${this.arrowCounter}`][0].scrollHeight;
      if (this.arrowCounter < this.templates.length - 1){ this.arrowCounter ++; }
    },
    onArrowUp(event){
      if (!this.showTemplates){
        return;
      }

      event.preventDefault();
      this.$refs[`templates`].scrollTop -= this.$refs[`li${this.arrowCounter}`][0].scrollHeight;
      if (this.arrowCounter > 0){ this.arrowCounter --; }
    },
    clearScroll() {
      this.scrollStatus.scrolled = 0
      this.$refs['chat-log'].$refs['chatContainer'].removeEventListener('scroll', this.handleScroll);
      this.scrollStatus.handleCreated = false
    },
    setScrollDown(time = 1, validade = false) {
      if (this.scrollStatus.scrolled >= 3 && validade) {
        return;
      }

      if (!this.scrollStatus.handleCreated) {
        this.$refs['chat-log'].$refs['chatContainer'].addEventListener('scroll', this.handleScroll);
        this.scrollStatus.handleCreated = true;
      }
      setTimeout(() => {
        this.$refs['chat-log'].$refs['chatContainer'].scrollTop = this.$refs['chat-log'].$refs['chatContainer'].scrollHeight;
        this.scrollStatus.scrolled++;
        if (this.notificationCount > 0) {
          this.clearNotification();
        }
      }, time); 
      
      this.isDownBtnVisible = false;
    },
    handleScroll() {
      const container = this.$refs['chat-log'].$refs['chatContainer'];
      if ((container.scrollHeight - container.scrollTop) > (container.clientHeight + 300)) {
        this.isDownBtnVisible = true;
        return;
      }
      
      this.isDownBtnVisible = false;
      if (this.notificationCount > 0) {
        this.clearNotification();
      }
    },
    async clearNotification() {
      this.ctService.resetUnseenMsg(this.activeChatUser.id)
      await this.$store.dispatch('chatContact/resetCustomerUnseenMsgs', {
        customerId: this.activeChatUser.customer.id,
        instanceId: this.activeChatUser.instance_id
      })

      this.notificationCount = 0;
      this.contactData[this.currentContactIndex].unseenMsg = 0;
    },
    onEnter(event) {
      if (event.shiftKey) {
        this.typedMessage = this.onShiftEnter('textArea', this.typedMessage);
        return;
      }

      if (this.templates && this.templates[this.arrowCounter]) {
        if (this.typedMessage.includes('/') && this.showTemplates) {
          let listOfSplitString = this.typedMessage.split(' ');
          listOfSplitString = listOfSplitString.filter((elementArray) => {
            return elementArray != '';
          })

          if (listOfSplitString[listOfSplitString.length - 1].includes('/')) {
            this.selectMessage(this.templates[this.arrowCounter]);
          }
        }

        setTimeout(() => {
          this.usingTemplate = false
          this.showTemplates = false
        }, 300)

        this.arrowCounter = -1;

        return;
      }

      if (this.commentActive) {
        this.sendComment()
      }

      this.sendMsg()
    },
    onEnterSearch() {
      this.searchChats()
    },
    onShiftEnter(obj, msg){
      var tArea = this.$refs[obj];
      var startPos = tArea.selectionStart;
      var endPos = tArea.selectionEnd;

      msg = msg.substring(0, startPos) + '\n' +
          msg.substring(endPos, msg.length);

      setTimeout(() => {
        tArea.selectionStart = tArea.selectionEnd = startPos + 1;
      }, 10);

      return msg;
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    selectMessage(template, onclick = false) {
      const customerName = this.activeChatUser.customer.name;
      let templateMessage = template.value

      const hasNameVariable = templateMessage.includes('{{nome_contato}}');

      if (hasNameVariable) {
        templateMessage = templateMessage.replace(/{{nome_contato}}/g, customerName);
      }

      if (this.typedMessage.includes( this.searchMessage ) || this.typedMessage[this.typedMessage.length -1] == '/') {
        let regex = new RegExp(`[${this.searchMessage}]*$`, 'gi');
        this.typedMessage = this.typedMessage.trim().replace(regex, "");
        this.searchMessage = '';
      }

      this.typedMessage += templateMessage
      this.usingTemplate =  true;

      if (onclick) {
        setTimeout(() => {
          this.usingTemplate =  true;
          this.showTemplates = false
        }, 300)

        this.arrowCounter = -1;
      }
      setTimeout(() => {
        this.scrollTopHandler()
      }, 5000)

    },
    checkTemplatePartial(partial) {
      var separators = ["' '", '\\\n'];
      var search = partial.split(new RegExp('('+separators.join('|')+')', 'g')).map(function(i){
        return i.trim();
      });

      search = search[search.length -1].split(' ');

      if (!partial || partial.length == 0 || search[search.length -1] == null) {
        this.usingTemplate = false;
        this.showTemplates = false
        return false
      }

      if(search[search.length -1][0] == '/') {
        this.usingTemplate = false
        this.templates = this.messageTemplates

        if(this.templates.length > 0) {
          this.templates = this.messageTemplates.filter(item => {
            return item.identifier.toLowerCase().indexOf(search[search.length -1].replace('/', '').toLowerCase()) > -1
          })
          this.searchMessage = search[search.length -1];
          this.arrowCounter = 0

          return true
        }

        return false
      }
      return false
    },
    clearReplyMessage() {
      this.$store.dispatch('chat/setReplyMessage', null);
      this.replyMessageId = null;
    },
    refuseTicketTransfer() {
      this.$store.dispatch('ticketTransfer/deleteTicketTransfer', this.ticketTransfer.id).then(() => {
        this.ticketTransferPopup = false
        if (this.finishedTickets === false) {
          this.queryObservable();
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    confirmTicketTransfer() {
      this.ticketTransferPopup = false
      this.$store.dispatch('ticketTransfer/confirmTicketTransfer', this.ticketTransfer.id).then(() => {
        if (this.finishedTickets === false) {
          this.queryObservable();
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    updateTimer() {
      if (this.ticketTransfer) {
        this.timer = new Date(this.ticketTransfer.transfer_at) - new Date()
      }

      return 0
    },
    resetActiveChatUser() {
      this.activeChatUser = null;
      this.$store.dispatch('chatContact/changeSelectedCustomer', { customerId: null, instanceId: null })
      setTimeout(() => {
        this.$vs.loading.close('#chat-app > .con-vs-loading')
      }, 100)
    },
    successUploadImage(response) {
      const quantityFile = this.$refs.uploadComponent.postFiles;
      if(quantityFile >= 1 && response.data){
        setTimeout(() => { 
          this.uploadComplete = true;
        }, 3000); 
      }
      const parsedResponse = JSON.stringify(response.data);
      if ( parsedResponse === JSON.stringify(this.imageUrl) ) { return; }

      this.imageUrl = JSON.parse(parsedResponse);
      this.$vs.notify({
        color: "success",
        title: "Anexo carregado com sucesso!",
        text: response.data.message,
      });
    },
    watchImageCaption(response) {
      const parsedResponse = JSON.stringify(response.data);
      if ( parsedResponse === JSON.stringify(this.imageUrl) ) { return; }
      this.imageUrl = JSON.parse(parsedResponse);
    },
    errorUploadImage(response) {
      this.uploadComplete = false
      this.$vs.notify({
        color: "danger",
        title: "Ocorreu um erro ao subir o anexo!",
        text: response.data && response.data.message ? response.data.message : ""
      });
    },
    deleteUploadImage(args = null) {
      this.fileName = null;
      if (args && args.method === "number" ) {
        const itemIndex = this.imageUrl.findIndex((c) => c.name === args.file.name);
        if ( itemIndex !== -1) {
          return this.imageUrl.splice(itemIndex, 1);
        } else if ( this.imageUrl.length > 0 ) { return; }
      } else if (args === null) {
        this.$refs.uploadComponent.removeFile(null, true);
      }

      this.imageUrl = [];
      this.uploadComplete = false;
    },
    openImageModal() {
      this.popupActive = true;
    },
    closeImageModal(){
      this.popupActive = false;
      this.deleteUploadImage()
    },
    openStockImages(){
      this.showImagesStock = !this.showImagesStock
    },
    closeStockImages(){
        if(this.showImagesStock){
          this.showImagesStock = !this.showImagesStock
        }
    },
    openAudioNotAllowedModal() {
      this.audioNotAllowedPopupActive = true;
    },
    openAudioNotFoundError() {
      this.audioNotFoundPopupActive = true;
    },
    YourPaste(event) {
      if (!this.popupActive && !this.commentActive) {
        const message = this.typedMessage;
        let isFile    = false;
        this.typedMessage = "";
        this.$refs.uploadComponent.removeFile(0, true);
        const items = event.clipboardData.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") == -1) continue;
          const fileObject = items[i].getAsFile();
          const fakeEvent = {
            target: {
              value: event.clipboardData.getData("text"),
              result: undefined,
              files: [fileObject],
            },
          };
          this.$refs.uploadComponent.getFiles(fakeEvent, true);
          isFile = true;
          this.popupActive = true;
        }
        if (items.length <= 3 ) {
          this.typedMessage = message;
          this.fileName     = message;
        }
        if (isFile) {
          setTimeout(() => {
            this.typedMessage = message;
            this.fileName     = message;
          }, 200);
        }
      }
    },
    sendImage(fileType = 'image', fileUrl = null, customerId = null, phoneNumber = null) {
      this.isSendingMessage = true;
      if (!customerId) {
        customerId = this.activeChatUser.customer.id;
      }

      if (!phoneNumber) {
        phoneNumber = this.activeChatUser.customer.phone_number;
      }

      if (fileUrl) { fileUrl = [{ url: fileUrl, name: '' }]; }
      else { fileUrl = this.imageUrl; }

      this.popupActive = false;
      this.closeImageModal();
      if (document.getElementsByClassName('btn-x-file')[this.countImageSent] !== undefined) {
        document.getElementsByClassName('btn-x-file')[this.countImageSent].click();
      }

      this.setScrollDown(2500);
      fileUrl.forEach( (file, index) => {
        this.countImageSent += 1;
        this.submitFile(customerId, phoneNumber, fileType, file.url, file.name, fileUrl.length === index + 1, (file.caption || ''));
      });

      if (this.newChat) {
        setTimeout(() => {
          this.$vs.loading({
            container: '#chat-app',
            text: 'Iniciando atendimento...',
            background: '#c3c3c3',
            scale: 0.6
          });
        }, 100);
      }

      this.deleteUploadImage();
      setTimeout(() => {
        this.scrollTopHandler();
      }, 5000);
    },
    sendFile(fileType = 'audio', fileUrl = null, customerId = null, phoneNumber = null, index = null) {
      this.isSendingMessage = true;
      if(!customerId) {
        customerId = this.activeChatUser.customer.id;
      }

      if (!phoneNumber) {
        phoneNumber = this.activeChatUser.customer.phone_number;
      }

      if (fileType !== 'audio') {
        if (document.getElementsByClassName('btn-x-file')[this.countImageSent] !== undefined) {
          document.getElementsByClassName('btn-x-file')[this.countImageSent].click();
        }
        this.countImageSent += 1;
      }

      this.$store.dispatch('setShowLoadingOverlay', false);
      this.submitFile(customerId, phoneNumber, fileType, fileUrl, '', true, '', index);

      if (this.newChat) {
        setTimeout(() => {
          this.$vs.loading({
            container: '#chat-app',
            text: 'Iniciando atendimento...',
            background: '#c3c3c3',
            scale: 0.6
          })
        }, 100)
      }

      this.deleteUploadImage();
      setTimeout(() => {
        this.scrollTopHandler();
      }, 5000);
    },
    submitFile(customerId, phoneNumber, fileType, fileUrl, fileName = '', isLast = true, caption = '', index = null) {
      const prepareMsg  = this.prepareIndexedMsg( customerId, fileUrl, fileType );
      let hash          = prepareMsg.hash;
      let indexedMsg    = prepareMsg.indexedMsg;
      let imageCaption  = caption ? caption : '';

      this.popupActive      = false;
      this.showImagesStock  = false;
      if (this.chatReplyMessage) {
        this.$store.dispatch('chat/setReplyMessage', this.chatReplyMessage);
      }

      const payload = {
        timeout: this.newChat ? 25 : null,
        hash: this.newChat ? 'start-' + hash : hash,
        ...(
          index !== null ? this.mediaInfo[index]
          : {
            customerId: customerId,
            toNumber: phoneNumber,
            userId: this.activeUser.id,
            instanceId: this.activeChatUser.instance_id
          }
        )
      };

      if (index !== null) {
        this.mediaInfo.splice(index, 1);
      }

      if ( fileType === 'sticker') {
        this.$store.dispatch("chatContact/sendChatSticker", {
          ...payload,
          imageUrl    : fileUrl
        }).then(() => {
          this.isSendingMessage = false
          this.setScrollDown();
          this.$vs.notify({
            color: 'success',
            title: 'Figurinha enviada com sucesso!'
          })
        }).catch((error) => {
          console.error(error);
          const errorMessage = error.response.data.errors[0].message || '';

          this.isSendingMessage = false;
          this.$vs.loading.close('#chat-app > .con-vs-loading');

          indexedMsg.ack = -1;
          this.ccService.updateAckCustomerChat(indexedMsg)

          if ( errorMessage.includes('Atendimento aberto a mais de 24') ){
            return this.popupReactivateChat = true;
          }

          this.$vs.notify({
            time: 8000,
            color: "danger",
            title: "Ocorreu um ao enviar a figurinha!",
            text: "Ocorreu um erro de comunicação com o WhatsApp. Tente enviar a mensagens novamente em alguns instantes.",
          });

          this.closeImageModal();
        });
      } else if ( fileType === 'audio') {
        this.$store.dispatch("chatContact/sendChatAudio", {
          ...payload,
          fileUrl        : fileUrl,
          fileCaption    : imageCaption,
          replyMessageId : (this.chatReplyMessage) ? this.chatReplyMessage.id : null
        }).then(() => {
          this.isSendingMessage = false
          this.$vs.notify({
            color: 'success',
            title: 'Audio enviado com sucesso!'
          })
        }).catch((error) => {
          console.error(error);
          const errorMessage = error.response.data.errors[0].message || '';

          this.isSendingMessage = false;
          this.$vs.loading.close('#chat-app > .con-vs-loading');

          indexedMsg.ack = -1;
          this.ccService.updateAckCustomerChat(indexedMsg)

          if ( errorMessage.includes('Atendimento aberto a mais de 24') ){
            return this.popupReactivateChat = true;
          }

          this.$vs.notify({
            time: 8000,
            color: "danger",
            title: "Ocorreu um ao enviar o audio!",
            text: "Ocorreu um erro de comunicação com o WhatsApp. Tente enviar a mensagens novamente em alguns instantes.",
          });

          this.closeImageModal();
        });
      } else {
        this.$store.dispatch("chatContact/sendChatImage", {
          ...payload,
          imageUrl    : fileUrl,
          fileName    : fileName,
          imageCaption: imageCaption
        }).then(() => {
          this.isSendingMessage = false;
          if( isLast ){
            this.$vs.notify({
              color: 'success',
              title: `${fileType === 'image' ? 'Imagem' : 'Arquivo(s)'} encaminhado com sucesso!`,
            });
          }
        }).catch((error) => {
          console.error(error);
          const errorMessage = error.response.data.errors[0].message || '';

          this.isSendingMessage = false;
          this.$vs.loading.close('#chat-app > .con-vs-loading');

          indexedMsg.ack = -1;
          this.ccService.updateAckCustomerChat(indexedMsg)

          if ( errorMessage.includes('Atendimento aberto a mais de 24') ){
            return this.popupReactivateChat = true;
          }

          this.$vs.notify({
            time: 8000,
            color: "danger",
            title: "Ocorreu um ao enviar o Arquivo!",
            text: "Ocorreu um erro de comunicação com o WhatsApp. Tente enviar a mensagens novamente em alguns instantes.",
          });

          this.closeImageModal();
        });
      }

      this.ccService.insert([indexedMsg], false, true);
      this.$events.fire('RefreshObserverChatData', indexedMsg);
      this.createJob()

      this.clearReplyMessage()
      setTimeout(() => {
        this.scrollTopHandler()
      }, 5000)
    },
    prepareIndexedMsg(customerId, fileUrl, fileType) {
      const currentTime = new Date();
      const hash = generateHash(
          customerId,
          fileUrl,
          this.activeUser.id,
          this.activeChatUser.instance_id
      );
      const indexedMsg = {
        id              : 88888 * currentTime.getMilliseconds(),
        customer_id     : customerId,
        type            : 0,
        sent_at         : moment(new Date()).format('YYYY-MM-DD') + ' ' + currentTime.toLocaleTimeString(undefined, { hour12: false }),
        message         : fileUrl,
        tag_type        : fileType,
        document_name   : fileUrl.split('/').reverse()[0],
        is_temp         : 1,
        hash            : this.newChat ? 'start-' + hash : hash,
        ack             : 0,
        instance_id     : this.activeChatUser.instance_id,
        user_sending_id : this.activeUser.id,
        replyMessageId  : (this.chatReplyMessage) ? this.chatReplyMessage.id : null,
      }

      return { hash: hash,  indexedMsg: indexedMsg }
    },
    async searchChats() {
      this.refreshTable = false;
      this.currentPage = 1;
      this.searchQuery = this.searchQuery.replace('+55', '')
      if (this.searchQuery !== '') {
        await this.callApi(this.$store.state.chatContact.chatTab);
      } else {
        this.queryObservable(null, false)
      }
    },
    searchBlank() {
      // Se o usuário limpar o campo, faz a busca limpa para pegar todos os chats
      if (this.searchQuery === "") {
        this.searchChats();
      }
    },
    messageInputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey && !this.usingTemplate && !this.commentActive) {
        this.isSendingMessage = true;
        e.preventDefault();
        this.sendMsg();
      }
    },
    closeProfileSidebar(value) {
      this.$store.state.activeKnowPopupVariable = false
      this.activeProfileSidebar = value;
    },
    updateActiveChatUser(contact, reset = true, index = null) {
      this.$refs.uploadComponent.removeFile(null, true, true);
      this.currentContactIndex = index;
      this.selectContact = contact;
      if (contact.id !== undefined) {
        this.newChat = false;
      }

      this.setDefaultFilters();
      this.$store.dispatch("setShowLoadingOverlay", false);

      if (contact.is_finishing === true) {
        return this.$vs.notify({
          color: "warning",
          title: "Esse atendimento está encerrando!",
          text: "Você não pode abrir esse atendimento no momento pois ele está encerrando, tente outro atendimento."
        });
      }

      this.$events.fire('resetSelectedDate');
      const chatContact = JSON.parse(JSON.stringify(contact));

      if (chatContact.unseenMsg > 0 && !chatContact.inbox) {
        this.ctService.resetUnseenMsg(chatContact.id);
        this.queryObservable(null, false)
        this.$store.dispatch('chatContact/resetCustomerUnseenMsgs', {
          customerId: chatContact.customer.id,
          instanceId: chatContact.instance_id
        });

        const ticket = this.$store.state.chatSettings.sumOfTickets.my_chats_list.find(ticket => ticket.id === chatContact.id);
        ticket.unseenMsg = 0;
        this.filterMyChatsSum();
      }

      chatContact.unseenMsg = 0;
      this.$store.dispatch("settings/fetch");
      this.$store.commit('chatContact/UPDATE_CHAT_CONTACT', chatContact);
      this.$store.dispatch('chatContact/changeSelectedCustomer', {
        customerId: chatContact.customer.id,
        instanceId: chatContact.instance_id
      });

      this.indexSearch = 0;
      this.messageSearch = '';
      this.activeChatUser = contact;
      this.showTemplates = false;
      this.showImagesStock = false;
      this.activeNewChatSidebar = false;

      this.toggleChatSidebar();

      if (reset) {
        this.cancelAudio();
        this.imageUrl = [];
        this.typedMessage = "";
        this.audioGridActive = false;
      }

      this.scrollStatus.scrolled = 0;
    },
    showProfileSidebar(profileObject, openOnLeft = false) {
      this.profileObject = profileObject;
      this.isLoggedInUserProfileView = openOnLeft;
      this.activeProfileSidebar = !this.activeProfileSidebar;
    },
    closeNewChatSidebar(){
      this.activeNewChatSidebar = false;
      this.newChat = false;
    },
    toggleNewChatSidebar() {
      this.newChat = true;
      this.$store.dispatch('chatContact/setChatTab', 'my_chats');
      if (!this.activeNewChatSidebar) {
        this.$store.commit('chatContact/SET_SELECTED_CUSTOMER_CHATS', { items: [] })
      }
      this.activeNewChatSidebar = !this.activeNewChatSidebar
      this.newChat = this.activeNewChatSidebar;
      if (this.newChat) {
        this.commentActive = false;
      }
    },
    sendComment() {
      if (!this.typedMessage) return;
      const messageToSend = this.typedMessage;

      this.isSendingMessage = true;
      this.typedMessage = "";
      let hash = generateHash(
          this.activeChatUser.customer.id,
          messageToSend,
          this.activeUser.id,
          this.activeChatUser.instance_id
      );

      this.setScrollDown();

      this.$store
          .dispatch("chatContact/sendChatComment", {
            customerId: this.activeChatUser.customer.id,
            toNumber: this.activeChatUser.customer.phone_number,
            message: encodeToBase64(messageToSend),
            instanceId: this.activeChatUser.instance_id,
            hash: hash,
            timeout: null
          })
          .then((data) => {
            if (data.id === this.activeChatUser.id) {
              this.activeChatUser = data;
            }
            this.isSendingMessage = false;
            this.$store.dispatch("setShowLoadingOverlay", true);
          })
          .catch((error) => {
            console.error(error);

            this.isSendingMessage = false;
            this.$vs.loading.close('#chat-app > .con-vs-loading');

            return this.$vs.notify({
              time: 8000,
              color: "danger",
              title: "Ocorreu um ao enviar a mensagem!",
              text: "Ocorreu um erro ao adicionar o comentário. Tente enviar a mensagens novamente em alguns instantes.",
            });
          })
          setTimeout(() => {
            this.scrollTopHandler()
          }, 5000)
    },
    sendMsg() {
      if (!this.typedMessage) return;

      const settings      = this.$store.state.settings.settings;
      const messageToSend = this.typedMessage;
      let messageTemp     = messageToSend;

      if (parseInt(settings.show_username_on_chat)){
        messageTemp = "*" + this.activeUser.name + " diz:*"
            + '\n' + '\n' + messageToSend;
      }

      this.isSendingMessage = true;
      this.typedMessage = "";
      let currentTime = new Date();
      let hash = generateHash(
        this.activeChatUser.customer.id,
        messageToSend,
        this.activeUser.id,
        this.activeChatUser.instance_id
      );
      hash = this.newChat ? 'start-' + hash : hash

      const indexedMsg = {
        id                : 88888 * currentTime.getMilliseconds(),
        customer_id       : this.activeChatUser.customer.id,
        type              : 0,
        sent_at           : moment(new Date()).format('YYYY-MM-DD') + ' ' + currentTime.toLocaleTimeString(undefined, { hour12: false }),
        message           : messageTemp,
        tag_type          : 'stop_flow',
        document_name     : '',
        is_temp           : 1,
        hash              : hash,
        ack               : 0,
        replyMessageId    : (this.chatReplyMessage) ? this.chatReplyMessage.id : null,
        instance_id       : this.activeChatUser.instance_id,
        user_sending_id   : this.activeUser.id
      }

      this.setScrollDown();

      this.$store
          .dispatch("chatContact/sendChatMessage", {
            customerId: this.activeChatUser.customer.id,
            toNumber: this.activeChatUser.customer.phone_number,
            message: encodeToBase64(messageToSend),
            instanceId: this.activeChatUser.instance_id,
            userId: this.activeUser.id,
            replyMessageId: (this.chatReplyMessage) ? this.chatReplyMessage.id : '',
            hash: hash,
            timeout: (this.newChat) ? 15 : null
          })
          .then((data) => {
            if (data.id === this.activeChatUser.id) {
              this.activeChatUser = data;
            }
            this.isSendingMessage = false;
            this.$store.dispatch("setShowLoadingOverlay", true);
          })
          .catch((error) => {
            console.error(error);
            const errorMessage = error.response.data.errors[0].message || '';

            this.isSendingMessage = false;
            this.$vs.loading.close('#chat-app > .con-vs-loading');

            if ( errorMessage.includes('Atendimento aberto a mais de 24') ){
              return this.popupReactivateChat = true;
            }

            return this.$vs.notify({
              time: 8000,
              color: "danger",
              title: "Ocorreu um ao enviar a mensagem!",
              text: "Ocorreu um erro de comunicação com o WhatsApp. Tente enviar a mensagens novamente em alguns instantes.",
            });
          })

      this.ccService.insert([indexedMsg], false, true);
      this.$events.fire('RefreshObserverChatData', indexedMsg);
      this.createJob(hash)
      
      setTimeout(() => {
        this.scrollTopHandler()
        }, 5000)

      if (this.newChat) {
        this.lastNewMessage = indexedMsg.message;

        setTimeout(() => {
          this.$vs.loading({
            container: '#chat-app',
            text: 'Iniciando atendimento...',
            background: '#c3c3c3',
            scale: 0.6
          })
        }, 100)
      }

      this.$store.dispatch('chat/setReplyMessage', null);
    },
    setSidebarWidth() {
      this.isChatSidebarActive = this.clickNotClose = !(this.windowWidth < 1200)
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return;
      this.isChatSidebarActive = value;
    },
    changeChatDataList() {
      if (this.$refs.activeChatList) {
        let totalHeight   = 0;
        const attendances = this.$refs.activeChatList.querySelectorAll('li');
        attendances.forEach(attendance => totalHeight += attendance.offsetHeight);

        if (
          this.$refs.chatScroll.$el.scrollHeight === this.$refs.chatScroll.$el.clientHeight &&
          totalHeight < this.$refs.chatScroll.$el.scrollHeight &&
          attendances.length !== 0 &&
          this.existsOldMessages
        ) {
          this.currentPage = this.currentPage + 1;
          this.limit       = this.baseLimit * this.currentPage;
          this.searchingForCustomers = true;
          this.scroll      = true;
          this.oldHeight   = this.$refs.chatScroll.$el.scrollHeight;
          this.queryObservable();
        }
      }
    },
    scrollHandler() {
      const scrollTop = this.$refs.chatScroll.$el.scrollTop
      const scrollHeight = this.$refs.chatScroll.$el.scrollHeight
      const offsetHeight = this.$refs.chatScroll.$el.offsetHeight
      const SCROLL_FIXED_VALUE = 150 + (30 * this.currentPage);

      if (
          this.lastPage === false &&
          this.searchingForCustomers === false &&
          scrollTop > 0 &&
          scrollTop + SCROLL_FIXED_VALUE >= (scrollHeight - offsetHeight)
      ) {
        if (this.existsOldMessages) {
          this.currentPage = this.currentPage + 1;
          this.limit = this.baseLimit * this.currentPage
          this.searchingForCustomers = true
          this.scroll = true;
          this.oldHeight = this.$refs.chatScroll.$el.scrollHeight;
          this.queryObservable();
        }
      } 
    },
    scrollTopHandler(){
        this.$refs.chatScroll.$el.scrollTop = 0;
    },
    sendAudio() {
      if(this.mediaRecorder && this.mediaRecorder.state=='recording') {
        this.canSendAudio = true;
        this.mediaRecorder.stop();
        clearInterval(this.refreshIntervalId);
      }
      this.audioGridActive = false;
      setTimeout(() => {
        this.scrollTopHandler()
      }, 5000)
    },
    cancelAudio() {
      if (!this.mediaRecorder) {
        return
      }

      this.audioGridActive = false;
      if(this.mediaRecorder.state=='recording'){
        this.canSendAudio = false;
        this.mediaRecorder.stop();
        clearInterval(this.refreshIntervalId);
      }
      this.mediaRecorder = null
    },
    recordAudio() {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
        this.audioGridActive = true;
        this.showImagesStock = false;
        this.mediaRecorder = new MediaRecorder(stream);

        let CustomerId = this.activeChatUser.customer.id;
        let PhoneNumber = this.activeChatUser.customer.phone_number;
        const index = this.mediaInfo.length;
        this.mediaInfo[index] = {
          customerId : CustomerId,
          toNumber   : PhoneNumber,
          instanceId : this.activeChatUser.instance_id,
          userId     : this.activeUser.id
        }

        this.mediaRecorder.start();
        this.refreshIntervalId = setInterval(() => {
          this.audioSeconds++;
        }, 1000);

        this.mediaRecorder.addEventListener("dataavailable", event => {
          this.audioChunks.push(event.data);
        });

        if (this.audioChunks) {
          this.audioResend = this.audioChunks;
        }

        this.mediaRecorder.addEventListener("stop", () => {
          if ( this.canSendAudio ) {
            new Promise((resolve, reject) => {
              const audioBlob = new Blob(this.audioChunks, { 'type' : 'audio/mpeg-3' });
              const audioFile = new File([audioBlob], "audio.mp3");
              let formData = new FormData();
              formData.append('file', audioFile);

              axios.post(
                this.uploadApiUrl,
                formData,
                { headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.bearer} }
              ).then(response => {
                this.sendFile('audio', response.data.fileUrl, CustomerId, PhoneNumber, index);
                resolve();
              }).catch(error => {
                if (error.name === 'NotAllowedError') {
                  this.openAudioNotAllowedModal();
                } else if (error.name === 'NotFoundError') {
                  this.openAudioNotFoundError();
                }

                this.audioResend = this.audioChunks;
                this.cancelAudio();

                this.mediaInfo.splice(index, 1);
                console.error(error);
                reject();
              });
            })
          } else {
            this.mediaInfo.splice(index, 1);
          }

          this.audioChunks = [];
          this.mediaRecorder = null;
          stream.getTracks().forEach( track => track.stop());
          this.audioSeconds = 0;
          this.canSendAudio = false;
        });
      })
    },
    resendAudio(chat = null) {
      if (!chat && this.audioResend.length === 0 ) {
        return this.$vs.notify({
          color: "danger",
          title: "Não há dados de áudio para reenviar.",
        })
      }

      const customerId = this.activeChatUser.customer.id;
      const phoneNumber = this.activeChatUser.customer.phone_number;

      if ( chat.message && isUrl(chat.message) ){
        return this.sendFile('audio', chat.message, customerId, phoneNumber);
      }

      const audioBlob = new Blob(this.audioResend, { type: 'audio/mpeg-3' });
      const audioFile = new File([audioBlob], "audio.mp3");
      const formData = new FormData();
      formData.append('file', audioFile);

      axios.post(
        this.uploadApiUrl,
        formData,
        { headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.bearer }}
      ).then(response => {
        this.sendFile('audio', response.data.fileUrl, customerId, phoneNumber);
      }).catch(error => {
        console.error("Erro ao reenviar áudio:", error);
        this.$vs.notify({
          color: "danger",
          title: "Erro ao reenviar áudio!",
        })
      }).finally(() => {
        this.audioResend = [];
      });
    },
    formattedDate(date) {
      const { date_only, hour, minute } = formatDate(date)
      return `${date_only} ${hour}:${minute}`
    },
    onTransferringChat(chatTicket) {
      if (chatTicket.id === this.activeChatUser.id) {
        this.$events.fire('closeAllPopUps', true)
      }
      this.transferring = [...this.transferring, chatTicket.id];
    },
    onTransferredChat(chatTicket) {
      this.transferring = this.transferring.filter((id) => id !== chatTicket.id);
      const { customerId, instanceId } = this.$store.state.chatContact.selectedCustomerChats

      if (
        instanceId === chatTicket.instance_id
        && customerId === chatTicket.customer_id
        && chatTicket.previous_user_id === this.$store.state.AppActiveUser.id
      ) {
        this.resetActiveChatUser();
        return;
      }

      if (this.chatTab === 'inbox') {
        this.queryObservable('inbox', false)
      }
    },
    isTransferring(chatTicketId) {
      return this.transferring.indexOf(chatTicketId) > -1;
    },
    setDefaultFilters(){
      this.filterInstances = this.$store.getters["instance/chosenInstanceIds"];
      this.filterGroups = this.$store.getters["chatContact/groupsSelectedFilter"]
    },
    updateFilterInstances(selected){
      this.filterInstances = selected
    },
    updateFilterGroups(selected, clean = false){
      this.filterGroups = selected
      if (clean){
        this.filterGroups = []
        if ( this.$store.getters["chatContact/groupsSelectedFilter"].length > 0 ){
          this.reloadChatByFilter(clean);
        }
      }
    },
    reloadChatByFilter(clean = false){
      if (this.filterInstances.length > 0 || this.filterGroups.length > 0 || clean) {
        this.$vs.notify({
          color: 'warning',
          title: "Recarregando o Chat",
          text: 'Por favor, aguarde um momento enquanto implementamos a alteração no filtro.',
          time: 7000
        });

        if (this.filterInstances.length > 0){
          this.$store.dispatch("instance/chooseRefreshInstancesObject", instanceObject(this.filterInstances));
        }
        if (this.filterGroups.length > 0 || clean){
          this.$store.dispatch("chatContact/setGroupsSelectedFilter", this.filterGroups);
        }

        this.$store.dispatch("chatSettings/fetch");
        this.$router.push({
          path: formatRouteTenantPath("/instances/list/choose-instance"),
          query: {refresh: true}
        });
      }
    },
    openMyChats() {
      this.otherChatsOpened = false;
      this.$store.dispatch('chatContact/setChatTab', 'my_chats');
      this.clearScroll()
    },
    openOtherChats(status) {
      this.otherChatsOpened = status !== 'inbox';
      if (this.chatFilter === 'unseenMsg' && ['all', 'closed', 'opened'].includes(status)) {
        this.setChatOrigin('all')
      }
      this.$store.dispatch('chatContact/setChatTab', status);
      this.clearScroll()
    },
    setChatOrigin(origin) {
      this.$store.dispatch('setShowLoadingOverlay', false)
      this.$store.dispatch('chatContact/setChatFilter', origin);
    },
    setAdditionalChatOrigin(origin) {
      this.$store.dispatch('setShowLoadingOverlay', false)
      this.$store.dispatch('chatContact/setAdditionalChatOrigin', origin);
    },
    reloadChatTab() {
      this.queryObservable()
    },
    callTabs(tab = null, isCampaign = null) {
      const activeUser = this.$store.state.AppActiveUser

      if (tab === null) {
        tab = this.$store.state.chatContact.chatTab;
      }

      const department = tab === 'inbox' && activeUser.role.name !== 'administrador' && activeUser.userDepartment ? activeUser.userDepartment.id : null;

      if (isCampaign === null && this.$store.state.chatContact.chatFilter !== 'all') {
        isCampaign = this.$store.state.chatContact.chatFilter === 'campaign';
      }

      const params = {
        inbox: () => {
          return {
            instanceIds: this.$store.getters["instance/chosenInstanceIds"],
            groupIds: this.$store.getters["chatContact/groupsSelectedFilter"],
            isCampaign: isCampaign,
            finishedTickets: false,
            allUsers: true,
            inbox: true,
            inboxDepartment: department
          }
        },
        my_chats: () => {
          return {
            instanceIds: this.$store.getters["instance/chosenInstanceIds"],
            groupIds: this.$store.getters["chatContact/groupsSelectedFilter"],
            isCampaign: isCampaign,
            finishedTickets: false,
            allUsers: false
          }
        },
        opened: () => {
          return {
            instanceIds: this.$store.getters["instance/chosenInstanceIds"],
            groupIds: this.$store.getters["chatContact/groupsSelectedFilter"],
            isCampaign: isCampaign,
            finishedTickets: false,
            allUsers: true
          }
        },
        closed: () => {
          return {
            instanceIds: this.$store.getters["instance/chosenInstanceIds"],
            groupIds: this.$store.getters["chatContact/groupsSelectedFilter"],
            isCampaign: isCampaign,
            finishedTickets: true,
            allUsers: true
          }
        },
        byAttendant: () => {
          return {
            instanceIds: this.$store.getters["instance/chosenInstanceIds"],
            groupIds: this.$store.getters["chatContact/groupsSelectedFilter"],
            userId: this.contactId,
            isCampaign: isCampaign,
            allUsers: true
          }
        },
        all: () => {
          return {
            instanceIds: this.$store.getters["instance/chosenInstanceIds"],
            groupIds: this.$store.getters["chatContact/groupsSelectedFilter"],
            isCampaign: isCampaign,
            allUsers: true
          }
        }
      }

      return params[tab]();

    },
    async callApi(tab, isCampaign = null, showLoading = true, param = null) {
      if (!param) param = this.callTabs(tab, isCampaign);
      else param = JSON.parse(JSON.stringify(param))

      param.unseenMsg = { '>': 0 }
      param.importChat = true
      param.newChat = this.newChat;
      if (this.currentPage > 1) {
        param.paginationPage = this.currentPage;
      }
      if (this.searchQuery !== '') {
        setTimeout(() => {
          this.$vs.loading({
            container: `#image-profile`,
            text: 'Carregando contatos...',
            background: '#B3DEFF',
            scale: 0.6
          })
        }, 100)
        param.searchQuery = this.searchQuery;
      }
      await new Promise(() => {
        this.$store.dispatch("chatContact/fetch", param).then((data) => {
          if (this.refreshTable === true || data.data.data.chatTickets.items.length === 0) {
            setTimeout(() => {
              this.refreshTable = false;
              this.queryObservable(tab, showLoading);
            }, 3000)
          }
          this.newChat = false;
        }).catch(() => {
          this.searchingForCustomers = false
        })
      });
    },
    queryObservable(tab = null, showLoading = true) {
      if (this.$store.getters["instance/chosenInstanceIds"].length === 0) {
        return
      }

      this.setDefaultFilters()
      const activeUser = this.$store.state.AppActiveUser;
      const settings = this.$store.state.settings.settings;

      const department = (tab === 'inbox' || this.chatTab === 'inbox')
      && activeUser.role.name !== 'administrador'
      && !activeUser.userDepartment
          ? 0           // BUSCARÁ O ATENDIMENTO QUE NÃO TEM DEPARTAMENTO
          : undefined;  // Todos

      this.oldestFirst = false;
      this.oldestPriority = false;

      const query = {
        inbox: () => {
          this.queryValues = [{
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
            finished_ticket: 0,
            inbox: 1
          }]

          if ( department === 0 ){
            this.queryValues[0].inbox_department_id = department;
          }

          this.finishedTickets = true;
          this.oldestPriority = !!parseInt(settings.priority_tickets_in_passive_flow);
          this.oldestFirst = !!parseInt(settings.older_inbox_chats_first_only) || !!parseInt(settings.older_inbox_chats_obligatorie_in_first);
        },
        my_chats: () => {
          this.queryValues = [{
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
            finished_ticket: 0,
            user_id: activeUser.id
          }]
          this.finishedTickets = false
        },
        opened: () => {
          this.state = false;
          this.attendantImage = null;
          this.contactId = null;
          this.queryValues = [{
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
            finished_ticket: 0,
          }]
          this.finishedTickets = true
        },
        closed: () => {
          this.state = true;
          this.attendantImage = null;
          this.contactId = null;
          this.queryValues = [{
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
            finished_ticket: 1,
          }]
          this.finishedTickets = true
        },
        byAttendant: () => {
          if (this.state !== null) {
            this.queryValues = [{
              instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
              finished_ticket: this.state,
              user_id: this.contactId
            }]
            this.finishedTickets = true
          } else {
            this.queryValues = [{
              instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
              user_id: this.contactId
            }]
            this.finishedTickets = true
          }
        },
        all: () => {
          this.state = null;
          this.attendantImage = null;
          this.contactId = null;
          this.queryValues = [{
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
          }]
          this.finishedTickets = true
        }
      }

      const queryFilter = {
        campaign: () => {
          this.queryValues[0].is_campaign = 1
        },
        attendance: () => {
          this.queryValues[0].is_campaign = 0
        },
        maria: () => {
          this.queryValues[0].is_campaign   = 0
          this.queryValues[0].bot_is_active = 1
        },
        unseenMsg: () => {
          this.queryValues[0].is_campaign   = 0
          this.queryValues[0].bot_is_active = 0
          this.queryValues[0].unseenMsg = { '>': 0 }
        },
        all: () => {

        },
      }

      const queryAdditional = {
        search: () => {
          if (!this.additionalChatFilter || this.additionalChatFilter !== 'search'){
            return this.queryValues[0].is_research = 0
          }
          this.queryValues.push({
            ...this.queryValues[0],
            or: { is_research: 1 }
          })
        }
      }

      this.textSearch = null;
      if (this.searchQuery !== '') {
        let cleaned = this.searchQuery.replace(/[^a-zA-Z0-9\sÀ-ÿ\-\/]/g, '');
        let parsedPhone = this.searchQuery.replace(/[^0-9]+/g, '');
        const hasEmoji = this.searchQuery.match(/[^\p{L}\x00-\x7F]+/u);

        if (hasEmoji && hasEmoji[0]){
          cleaned += hasEmoji[0]
        }

        this.textSearch = {};
        this.textSearch.name = {
          like: '%'+cleaned+'%'
        }
        if (parsedPhone) {
          this.textSearch.or = {
            phone_number: {
              like: '%'+parsedPhone+'%'
            }
          }
        }
      }

      this.groupsFilter = null;
      const groupIds = this.$store.getters["chatContact/groupsSelectedFilter"];

      if (groupIds && groupIds.length > 0){
        this.groupsFilter = {}
        this.groupsFilter.group_id = {
          in: groupIds
        }
      }

      if (tab === null) {
        tab = this.$store.state.chatContact.chatTab;
      }

      if (!this.newChat && showLoading) {
        setTimeout(() => {
          this.$vs.loading({
            container: `#image-profile`,
            text: 'Carregando contatos...',
            background: '#B3DEFF',
            scale: 0.6
          })
        }, 200)
      }

      this.observerTicketData(query[tab](), queryFilter[this.chatFilter](), queryAdditional['search']())

      /*regras para exibição das abas
      Inbox
        instance_id -> instância padrão
        finishedTicket -> false
        all_users -> true
        inbox -> true
        inbox_department_id -> informado valor caso perfil diferente de administrador e tenha usuário que tenha departamento vinculado
      my_chats
        instance_id -> instância padrão
        finishedTicket -> false
        all_users -> false
        inbox -> null
        inbox_department_id -> null
      opened
        instance_id -> instância padrão
        finishedTicket -> false
        all_users -> false
        inbox -> null
        inbox_department_id -> null
      closed
        instance_id -> instância padrão
        finishedTicket -> true
        all_users -> true
        inbox -> null
        inbox_department_id -> null
      all
        instance_id -> instância padrão
        finishedTicket -> null
        all_users -> true
        inbox -> null
        inbox_department_id -> null
       */

    },
    observerTicketData() {
      this.ctService.getChatTicketsByTab(this.queryValues, this.limit, this.textSearch, this.groupsFilter, this.oldestFirst, this.oldestPriority)
          .then(data => {
            
            this.countLoop += 1;
            if (this.$store.state.chatContact.chatTab === 'my_chats' && data.length === 0 && this.countLoop <= 3 && this.searchQuery === '') {
              setTimeout(() => {
                this.observerTicketData();
              }, 3000)
              return;
            }

            if (this.scroll && this.existsOldMessages) {
              this.scroll = false;
              this.callApi(this.$store.state.chatContact.chatTab);
              setTimeout(() => {
                this.observerTicketData();
              }, 3000)
              return;
            }

            this.existsOldMessages = (this.limit - data.length) <= this.baseLimit;
            this.contactData = data;
            this.refreshTable = false;
            this.searchingForCustomers = false
            setTimeout(() => {
              this.$vs.loading.close('#image-profile > .con-vs-loading')
            }, 500)
          })
    },
    async fetchContactsData(call = false) {
      let param = this.callTabs(this.$store.state.chatContact.chatTab);

      if (this.chatTab === 'byAttendant' && this.contactId){
        param.userId = this.contactId;
        param.finishedTickets = this.oldValueChatTab === 'closed'

        if (this.oldValueChatTab && ['all', 'byAttendant'].includes(this.oldValueChatTab)){
          delete param.finishedTickets
        }
      }

      this.$store.dispatch('chatContact/chatTicketByUserId', param).then((res) => {
        this.contactDataLength = res.data.data.chatTicketsUserId;
      })

      if (call){
        await this.callApi(this.$store.state.chatContact.chatTab, null, false, param)
      }
    },
    checkPaginationByTab(tab = null, showLoading = false){
      const activeUser = this.$store.state.AppActiveUser;
      const department = (tab === 'inbox' || this.chatTab === 'inbox')
            && activeUser.role.name !== 'administrador'
            && !activeUser.userDepartment ? 0 : undefined;

      const query = {
        inbox: () => {
          let queryVal = {
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
            finished_ticket: 0,
            inbox: 1
          }

          if (department === 0) {
            queryVal.inbox_department_id = department;
          }

          return queryVal;
        },
        my_chats: () => {
          return {
            instance_id: {in: this.$store.getters["instance/chosenInstanceIds"]},
            finished_ticket: 0,
            user_id: activeUser.id
          }
        }
      }

      this.ctService.countChatTicketsByTab(query[tab]()).then((count) => {
        if (
            count === 7
            && ((
              tab === 'inbox'
              && this.$store.state.chatSettings.sumOfTickets.inbox_list.length >= count
            ) || (
              tab === 'my_chats'
              && this.$store.state.chatSettings.sumOfTickets.my_chats_list.length >= count
            ))
        ){
          this.callApi(tab, false, showLoading);
        }
      });
    },
    async filterMyChatsSum() {
      const tickets = this.$store.state.chatSettings.sumOfTickets.my_chats_list;
      const resolve = await Promise.all(tickets.map(async (ticket) => { return await populateQuerySum(this.cgService, this.chatFilter, ticket); }));
      const sum = resolve.filter(result => result).length;
      this.myChatsSum = sum < 100 ? sum : '+99'
    },
    createJob(hash) {
      this.$crontab.addJob({
        name: hash,
        interval: {
          seconds: '/15',
        },
        sync: 1,
        job: this.verifyMessageApi
      })
    },
    verifyMessageApi({name}) {
      let ticket = [
        {
          instance_id: null,
          customer_id: null,
          hash: name
        }
      ]
      CustomerChat.loadPaginated(ticket, 1, 1, true);
    },
    deleteJob(hash) {
      this.$crontab.disableJob(hash);
    },
    async dispatchPingPong(timestamps = null, refresh = false) {
      const threshold   = 60;
      let lowMemory     = false;
      let storageUsage  = false;
      let dateToRefresh = new Date();
      let dateToReload  = new Date();

      if ( !timestamps || timestamps instanceof Event ){
        timestamps = this.$store.state.socketConnectionCount
      } else {
        await this.$store.dispatch('socketConnectionCount', timestamps)
      }

      dateToRefresh.setSeconds(dateToRefresh.getSeconds() - 40);
      dateToRefresh.setMilliseconds(0);
      dateToReload.setMinutes(dateToRefresh.getMinutes() - 60);
      dateToReload.setMilliseconds(0);
      let dateVuex = new Date(timestamps);

      try {
        storageUsage = await navigator.storage.estimate();
      } catch (e) {}

      if ( storageUsage && storageUsage['usage'] && storageUsage['quota'] ){
        const percentUsed = (storageUsage['usage'] / storageUsage['quota']) * 100;
        console.warn(`Maximum: ${threshold}% - Storage Usage: ${percentUsed.toFixed(2)}%`);
        console.warn(storageUsage);
        if (percentUsed > threshold){
          lowMemory = true;
        }
      }

      if ((dateToReload.getTime() > dateVuex.getTime()) || dateToRefresh.getTime() > dateVuex.getTime() || refresh) {
        this.$vs.notify({
          color: 'warning',
          title: "Sincronização chat",
          text: 'Seu chat esta sendo sincronizado com nossos servidores',
          time: 7000,
        })

        await this.$store.dispatch("chatSettings/fetch");
        await this.$store.dispatch("instance/chooseRefreshInstancesObject", this.$store.getters["instance/chosenInstances"]);
      }

      if (lowMemory){
        connect();
        await this.ctService.clearTable([], this.chatTab);
      } else if (dateToReload.getTime() > dateVuex.getTime()) {
        await this.$router.push({
          path: formatRouteTenantPath("/instances/list/choose-instance"),
          query: {refresh: true}
        });
      } else if (refresh || dateToRefresh.getTime() > dateVuex.getTime()) {
        connect();
        await chatContact.firstLoad(true);
      }
    },
    updateChatNavbarWithNewData(parameter) {
      this.activeChatUser.customer.phone_number = parameter.phone_number;
      this.activeChatUser.customer.name = parameter.name;
    },
    searchMessages(indexSearch, searchQuery) {	
      this.messageSearch  = searchQuery;	
      this.indexSearch    = indexSearch;	
      this.$refs['chat-log'].searchMessages()	
    },	
    updateMaxSearch(value) {	
      this.$refs['chat-navbar'].maxValues = value	
    },
    playAudioHowl(audioSrc) {
      if (!this.audioMap[audioSrc]) {
        this.audioMap[audioSrc] = new Howl({
          src: [audioSrc],
          format: ['mp3', 'ogg', 'wav'],
        });
      }
      
      if (!this.audioMap[audioSrc].playing()) {
        this.audioMap[audioSrc].play();
      }
    },
    pauseAudio(audioSrc) {
      if (this.audioMap[audioSrc]) {
        this.audioMap[audioSrc].pause();
      }
    },
    finishAudios() {
      for (const audioSrc in this.audioMap) {
        if (Object.prototype.hasOwnProperty.call(this.audioMap, audioSrc)) {
          const audio = this.audioMap[audioSrc];
          if (audio.playing()) {
            audio.pause();
          }
        }
      }
    },
    async closeChat(){
      this.popupReactivateChat = false;
      if (!this.activeChatUser) { return console.error('ActiveChatUser empty'); }

      this.$store.dispatch('chatContact/setChatFinalizePopup', this.activeChatUser);
      this.$store.dispatch('chatContact/changeStatusFinalizePopupActive', true);
    },
    async openMetaMessage(){
      this.popupReactivateChat = false;
      if (!this.activeChatUser || !this.activeChatUser.customer) { return console.error('ActiveChatUser empty'); }

      this.$events.emit('openMetaMessageTemplate', {
        activeChatUser: this.activeChatUser,
        instanceId: this.activeChatUser.instance_id
      });
    },
    async openActiveChatUser(customer, changedPhone) {
      let data = customer
      data.customer = (await customerApi.newAttendanceToCustomer({
        phoneNumber: customer.phone_number,
        instanceId: this.activeChatUser.instance_id
      })).data.data.newAttendanceToCustomer

      setTimeout(() => {
        if (data.customer.has_valid_phone_number === false){
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Use um número válido!'
          })
        } 
      }, 5000);
    },
    handleSelectedContact(id, action) {
      if ( action && !this.selectedContacts.includes(id) ) {
        this.selectedContacts.push(id);
        return;
      }

      if ( !action ) {
        const index = this.selectedContacts.indexOf(id);

        if ( index !== -1 ) {
          this.selectedContacts.splice(index, 1);
        }
        return;
      }
    },
    setDate(date) { this.searchDate = date; }
  },
  components: {
    Picker,
    Button,
    Upload,
    ChatLog,
    NewChat,
    VsDropdown,
    ChatNavbar,
    ChatContact,
    UserProfile,
    InboxButton,
    VueCountdown,
    StatusChecker,
    GetOrderByMsg,
    FinalizePopup,
    VsDropdownMenu,
    VsDropdownItem,
    ContactDropdown,
    ViewStockImages,
    InstancesSlimList,
    InboxContactPicker,
    VuePerfectScrollbar,
    TransferTicketPopup,
    CustomersListForward,
    BulkTransferComponent,
    CustomerCategorySlimList,
    ExpandableImage
  },
  beforeMount() {
    this.finishedTickets = false;
    this.oldValueChatTab = null;
  },
  created() {
    this.cgService = new CustomerGroupService();
    this.ccService = new CustomerChatService();
    this.ctService = new ChatTicketService();

    this.checkScreenWidth();
    window.addEventListener('resize', () => {
      this.checkScreenWidth();
      this.changeChatDataList();
    });

    this.$events.off('sendPreOrderSummaryToCustomer');
    this.$events.on('sendPreOrderSummaryToCustomer', (data) => {
      this.prePreOrderMessageTemplate(data)
    })

    this.resetActiveChatUser();

    if (this.$store.getters["instance/chosenInstanceIds"].length === 0) {
      return this.$router.push(
          formatRouteTenantPath("/instances/list/choose-instance")
      );
    }

    this.$events.off('closeModalSelectedContacts')
    this.$events.on('closeModalSelectedContacts', (value) => {
      this.showSelectList = value;
    })

    this.$events.off('RefreshQueryObservable')
    this.$events.on('RefreshQueryObservable', (showLoading = true) => {
        this.queryObservable(null, showLoading)
    })

    this.$events.off('ForwardChat')
    this.$events.on('ForwardChat', (data) => {
      this.setOpenCustomersList(data.showPopup);

      this.customerChatForwarded = data.customer_chat;
    })

    this.$events.off('ReplyOrder')
    this.$events.on('ReplyOrder', (value, message) => {
      if (value) {
        this.$store.dispatch('chat/setReplyMessage', this.whichChat);
        this.sendOrderAccepted(message)
      } else {
        this.$store.dispatch('chat/setReplyMessage', this.whichChat);
        this.sendOrderRejected(message)
      }
    })

    this.$events.off('GetOrderByMsg')
    this.$events.on('GetOrderByMsg', (data, messageDecode, chat) => {
      this.amountCash = messageDecode.amount;

      this.orders = [];

      this.ccServiceOrderByMsg.getByWhere({ 
        customer_chat_id: chat.id
      }).then(async (res) => {
        if (res.length > 0) {
          this.orders = res
        }
      });


      if (this.orders.length === 0) {
        this.orders = data
      }

      this.whichChat = chat;
      this.$events.fire('selectContact', this.selectContact, this.amountCash)
      this.addNewDataSidebar = true;
      
    })

    this.$events.off('DeleteJobReceivedMessage')
    this.$events.on('DeleteJobReceivedMessage', (hash) => {
      this.deleteJob(hash);
    })

    this.$events.off('NotificationsLabels')
    this.$events.on('NotificationsLabels', (event) => {
      if(event.label != 'research') {
        return
      }

      this.$store.commit('chatContact/UPDATE_RESEARCH', {
        chatId: event.item.id,
        active: true
      })

      if( this.activeChatUser && this.activeChatUser.id) {
        let item = this.chatContacts.filter((i) => i.id == this.activeChatUser.id);
        if (item.length > 0) {
          this.updateActiveChatUser(item[0])
        }
      }

    });
    this.$events.off('ChatTicketChanged')
    this.$events.on('ChatTicketChanged', async ({chatTicket, tenantName}) => {
      if (tenantName === getCurrentTenant() && chatTicket) {
        new Promise(() => {
          setTimeout(() => {
            if ( this.activeChatUser && this.activeChatUser.id && this.activeChatUser.id === chatTicket.id ) {
              const chatUpdated = this.contactData.filter((i) => i.id === this.activeChatUser.id);
              const { is_campaign, open_by_template } = chatTicket;
              let hasChange = false;

              if (chatUpdated.length === 0){
                return;
              }

              if ((
                  this.activeChatUser.open_by_template !== undefined
                  && this.activeChatUser.open_by_template !== open_by_template
                ) || (
                  this.chatFilter !== 'all'
                  && this.activeChatUser.is_campaign !== undefined
                  && this.activeChatUser.is_campaign !== is_campaign
              )){ hasChange = true }

              this.updateActiveChatUser(chatUpdated[0], hasChange)
            }
          }, 500)
        })
      }
    })
    this.$events.off('chatTicketResearchCanceled')
    this.$events.on('chatTicketResearchCanceled', async ({chatTicket, tenantName }) => {
      if ( tenantName === getCurrentTenant() && chatTicket) {
        new Promise(() => {
          setTimeout(() => {
            if( this.activeChatUser && this.activeChatUser.id) {
              let item = this.chatContacts.filter((i) => i.id == this.activeChatUser.id);
              if (item.length > 0) {
                this.updateActiveChatUser(item[0])
              }
            }
          }, 500)
        })

        this.$store.commit('chatContact/UPDATE_RESEARCH', {
          chatId: chatTicket.id,
          active: false
        })
      }
    })
    this.$events.off('TransferredChat')
    this.$events.on('TransferredChat', (data) => {
      this.onTransferredChat(data);
    })

    this.$events.off('UpdateActiveChatUser')
    this.$events.on('UpdateActiveChatUser', (data) => {
      this.updateActiveChatUser(data)
    })

    this.$events.off('notifyBotIsActiveChanged');
    this.$events.on('notifyBotIsActiveChanged', (data) => {
      const chatContact = this.contactData.filter( item => item.id === data.id );

      if ( chatContact.length === 0 ) {
        return;
      }

      chatContact[0].bot_is_active = Number(data.bot_is_active);
      this.$store.commit('chatContact/UPDATE_CHAT_CONTACT', chatContact[0]);
    });

    this.$events.off('notifyTriageFlowFinishedByMessageLimit');
    this.$events.on('notifyTriageFlowFinishedByMessageLimit', (data) => {

      const notification = {
        color: 'success',
        title: 'O limite de mensagens trocadas com o bot foi atingido!',
        text: `O(a) cliente ` + data.name + ` de número ` + data.phone_number + ` atingiu o número máximo de mensagens trocadas com a Maria`,
        time: 9000
      }

      if ( this.$store.state.AppActiveUser.id === data.user_id ) {
        this.$vs.notify( notification );
      }
      else if ( data.user_id == null ) {
        this.$vs.notify( notification );
      }

    });

    this.setSidebarWidth();
    this.filterMyChatsSum()

    if (!moduleSettings.isRegistered) {
      this.$store.registerModule("settings", moduleSettings);
      moduleSettings.isRegistered = true;
    }

    if (!this.$store.hasModule('messageTemplates')) {
      this.$store.registerModule("messageTemplates", moduleMessageTemplate);
      moduleMessageTemplate.isRegistered = true;
    }

    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customer", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }

    if (!moduleStockImages.isRegistered) {
      this.$store.registerModule("stockImages", moduleStockImages);
      moduleStockImages.isRegistered = true;
    }

    if (!moduleChatSettings.isRegistered) {
      this.$store.registerModule("chatSettings", moduleChatSettings);
      moduleChatSettings.isRegistered = true;
    }

    if (this.$store.state.messageTemplates.templates.length === 0) {
      this.$store.dispatch('messageTemplates/loadMessageTemplates')
    }

    this.$store.dispatch("settings/fetch")

    this.$store.dispatch('chatContact/resetCustomersToRemoveIds')

    this.$store.dispatch("ticketTransfer/socketListeners")

    this.$store.dispatch("stockImages/fetch")

    this.$store.dispatch("chatSettings/fetch")

    this.$events.off('ChatTicketTransferTimer')
    this.$events.on('ChatTicketTransferTimer', async (ticketTransfer) => {
      this.ticketTransfer = ticketTransfer
      this.updateTimer()
      await new Promise(resolve => setTimeout(resolve, 800));
      this.ticketTransferPopup = true
    })

    this.$events.off('CallAPI')
    this.$events.on('CallAPI', (tab, campaign = true, showLoading = true) => {
      this.refreshTable = true;
      this.callApi(tab, campaign, showLoading)
    })

    this.$events.off('ChangeUnseenMsg')
    this.$events.on('ChangeUnseenMsg', (value) => {
      if (value && value.chatTicket && value.chatTicket.unseenMsg > 0) {
        const ticket = this.$store.state.chatSettings.sumOfTickets.my_chats_list.find(ticket => ticket.id === value.chat_ticket_id);
        if (ticket) {
          ticket.unseenMsg = value.chatTicket.unseenMsg;
        }
      }

      this.ctService.updateUnseenMsg(value);
      if (this.activeChatUser && value.customer_id === this.activeChatUser.customer.id) {
        this.notificationCount++
      }
    })

    this.$events.off('ChatTicketTransferredReloadChatTickets')
    this.$events.on('ChatTicketTransferredReloadChatTickets', async ({
      chatTicket,
      instanceId,
      tenantName,
      inbox = false
    }) => {
      if ( tenantName !== getCurrentTenant() || !this.$store.getters["instance/chosenInstanceIds"].includes( instanceId )) {
        return;
      }

      if ( chatTicket.user_id === this.$store.state.AppActiveUser.id ) {
        this.$vs.notify({
          color: 'success',
          title: 'Transferência concluída!',
          text: `Acesse meus atendimentos abertos`,
          time: 7000
        })
      }

      if (
          inbox
          && this.chatTab === 'inbox'
          && chatTicket.user_id !== this.$store.state.AppActiveUser.id
      ) {
        this.queryObservable('inbox', false)
        return;
      }

      if ((chatTicket.user_id === this.$store.state.AppActiveUser.id ||
          chatTicket.previous_user_id === this.$store.state.AppActiveUser.id) && this.finishedTickets === false) {
        if (chatTicket.customer_id === this.$store.state.chatContact.selectedCustomerChats.customerId) {
          this.queryObservable(null, false)
          return;
        }
        this.queryObservable(null, false)
      }
    })

    this.$events.off('ChatTicketClosed')
    this.$events.on('ChatTicketClosed', ({chatTicket, tenantName, instanceId}) => {
      if (tenantName === getCurrentTenant() && this.$store.getters["instance/chosenInstanceIds"].includes(instanceId) ) {
        if (chatTicket.user_id === this.$store.state.AppActiveUser.id && this.contactData != null) {
          this.queryObservable()
          if (
              !!this.activeChatUser
              && chatTicket.customer_id === this.activeChatUser.customer.id
              && chatTicket.instance_id === this.activeChatUser.instance_id
          ) {
            if (this.activeChatUser.id === chatTicket.id) {
              this.$events.fire('closeAllPopUps', true)
              setTimeout(() => {
                this.resetActiveChatUser()
              }, 2000);
            }
            else {
              this.resetActiveChatUser()
            }
          }
        }
      }
    })

    this.$events.off('ResetActiveUser')
    this.$events.on('ResetActiveUser', () => {
      this.resetActiveChatUser();
    })

    this.$events.off('UpdateCustomerInActiveUser')
    this.$events.on('UpdateCustomerInActiveUser', (data) => {
      if (
          this.activeChatUser
          && data.id === this.activeChatUser.customer.id
          && data.id === this.activeChatUser.customer_id
      ){
        this.activeChatUser.customer = JSON.parse(JSON.stringify(data))
      }
    })

    this.$events.off('CheckSocket')
    this.$events.on('CheckSocket', ({ timestamps, refresh }) => {
      this.dispatchPingPong(timestamps, refresh)
    })

    this.$events.off('CheckPagination')
    this.$events.on('CheckPagination', ({ inInbox }) => {
      const tab = inInbox ? 'inbox' : 'my_chats';
      this.checkPaginationByTab(tab, false);
    })

    this.$events.off('ChatTicketTransferReloadChatTickets')
    this.$events.on('ChatTicketTransferReloadChatTickets', () => {
      if (this.finishedTickets === true) {
        this.queryObservable(null, false)
        this.$events.fire('FetchTicketTransfer')
      }
    })

    this.$events.on('RefreshCountObservable', () => {
      this.filterMyChatsSum()
    })

    this.$events.off('DeleteChatTicketTransfer')
    this.$events.on('DeleteChatTicketTransfer', async ({
      ticketTransfer,
      instanceId,
      tenantName
    }) => {
      if (
          tenantName === getCurrentTenant() &&
          ticketTransfer.next_user_id === this.$store.state.AppActiveUser.id &&
          this.$store.getters["instance/chosenInstanceIds"].includes(instanceId)
      ) {
        this.$events.fire('DeleteChatTicketTransferCloseModal', {
          ticketTransfer,
          instanceId,
          tenantName
        })
        this.ticketTransfer = ticketTransfer
        this.refuseAttendancePopupActive = true
      }
    });

    this.queryObservable('my_chats');

    window.addEventListener('blur', this.dispatchPingPong);
    window.addEventListener('focus', this.dispatchPingPong);

  },
  beforeDestroy() {
    this.finishAudios()
    this.finishedTickets = false
    this.searchChats()

    this.$events.fire('closeAllPopUps')
    this.$store.dispatch('activeInstance', null)

    window.removeEventListener('blur', this.dispatchPingPong);
    window.removeEventListener('focus', this.dispatchPingPong);
    document.removeEventListener('keydown', this.handleEnterKey);
    this.$refs['chat-log'].$refs['chatContainer'].removeEventListener('scroll', this.handleScroll);
  },
  beforeRouteLeave(to, from, next) {
    if (this.addNewDataSidebar) {
        this.addNewDataSidebar = false;
        setTimeout( ()=> {
          next();
        }, 2);
    } else if (this.popupActive) {
      this.popupActive = false;
      setTimeout( ()=> {
        next();
      }, 2)
    }

    if (this.showCustomersList) {
        this.showCustomersList = false;
        setTimeout( ()=> {
          next();
        }, 2);
    }
    
    this.activePopupAlert = false;
    this.openExpandImagePopUp = false;
    this.$events.fire('closeAllPopUps')
    setTimeout(() => { next();}, 200)
  },
  async mounted() {
    const tenant = getCurrentTenant();
    this.dashBeta = dashBetas.includes(tenant);
    this.getUsers();

    this.isMounted = true;

    this.hasCatalogFeature = await hasFeature('catalog');
    this.hasErpFeature = await hasFeature('erps');

    this.$store.dispatch(
        'chatContact/initInboxMessaging',
        this.$store.getters["instance/chosenInstanceIds"]
    );

    this.ccServiceOrderByMsg = new OrderByMsgService();

    document.addEventListener("click", this.handleClickOutside);

    this.$store.dispatch('chatContact/setChatTab', 'my_chats');
    this.isOfficial = this.$store.state.instance.chosenInstances[0].is_official;
    document.addEventListener('keydown', this.handleEnterKey);
    this.typeConnection = localStorage.getItem('connectionDatabase');

    this.setChatOrigin('all')
    setTimeout(() => this.changeChatDataList(), 1500);
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";

#chats-list {
  h5.font-semibold {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .text-white {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.con-vs-loading {
  opacity: 0.8;
}

.fill-row {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  flex: 0 0 100%;
}

#div-with-loading {
  width: 200px;
  height: 200px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  box-shadow: 0px 3px 10px 0px rgba(0,0,0,.1);
}

.chat-upload-image-popup {
  .con-upload{
    display: flex;
    justify-content: center;
  }
  .con-img-upload {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
}

.message-textarea {
  height: 80px;
  resize: none;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0 0 0 0 transparent;
  border-radius: 3px;
  font-size: 1rem;
  font-size: 1rem;
  color: inherit;
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  line-height: 1.6;
  padding: 9px;
}

#chat-app .chat-content-area .chat-content-scroll-area {
  height: calc(100% - 174px) !important;
}

#chat-app .no-scroll-content {
  height: calc(var(--vh, 1vh) * 100 - 4.4rem);
}

#chat-app #new-chat-sidebar .vs-sidebar{
  max-width: 400px !important;
}

#chat-list-sidebar .chat-scroll-area {
  height: calc(100% - 14rem) !important;
  padding-bottom: 2.2rem;
}

.chat-scroll-area.chat-scroll-tickets {
  padding-bottom: 2.2rem;
}

.new-chat-button:hover {
  background: transparent !important;
  background-color: transparent !important;
}

.disabled-textarea-wrapper {
  background-color: rgba(136, 136, 136, 0.95);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.disabled-textarea-wrapper p {
  text-weight: bold;
  font-size: 22px;
  color: white;
  text-align: center;
}
.connection-active{
  margin-left: 20px;
  padding: 0.4rem !important;
}

.firefox-lock-icon {
  display: inline-block;
  width: 20px;
  height: 17px;
  vertical-align: -4px;
}

.attendance-span {
  font-size: 0.6rem !important;
}

.notification {
  top: auto;
  position: absolute;
  width: 25px;
  height: 25px;
  border: 1px solid;
  border-radius: 50%;

  small {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 0.25rem;
    justify-content:center;
  }
}

.ticket-transfer-span {
  font-size: 1rem !important;
}

#textarea {
  -moz-appearance: textfield-multiline;
  -webkit-appearance: textarea;
  border: 1px solid gray;
  font: medium -moz-fixed;
  font: -webkit-small-control;
  overflow: auto;
  padding: 2px;
  resize: both;
}

.transferred-chat {
  display: block;
  clear: both;
  padding: 5px 0 10px 0;
}

.transferred-chat > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.all-tickets-opened-span {
  padding: -0.25rem 2rem!important;
}

.transferred-chat:not(:last-child) {
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

#grid-stock{
  width: 100%;
  z-index: 999;
  bottom: 108px;
  max-height: 16em;
  overflow-y: scroll;
  text-align: center;
  background: white;
  position: absolute;
  justify-content: center;
  scroll-behavior: smooth;
}

#templates {
  position: absolute;
  bottom: 108px;
  background: white;
  width: 27%;
  justify-content: center;
  max-height: 10em;
  overflow-y: scroll;
  scroll-behavior: smooth;
  margin-left: 9em;
  border-radius: 10px 0 10px 0;

  .template-item {
    .icon {
      margin-right: 5px;
    }
    display: flex;
    scroll-behavior: smooth;
    align-content: flex-end;
    padding: 8px;
    cursor: pointer;

    &:hover {
      background: skyblue;
    }

    &:focus {
      background: red;
    }

    &.is-active {
      background: skyblue;
    }

  }
}

#comment-icon{
  width: 20%;
  bottom: 106px;
  margin-left: -10px;
  max-height: 2.3em;
  max-width: 5em;
  user-select: none;
  position: absolute;
  background: white;
  justify-content: center;
  border-radius: 10px 10px 0 0;
}

@media (max-width:500px) {
  #templates {
    width: 90%!important;
  }
}

.replyMessage {
  position: absolute;
  width: 100%;
  bottom: 108px;
  background: wheat;
  padding: 2px;

  div {
    margin-left: 12px;
  }
}

.chat-no-message {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #898989;
}

.chat-message-container {
  //padding-top: 20px;
  height: calc(100% + 20px);
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 400px;
  height: 300px;
}
#selectStyle-myAttendance{
  color: white;
  background-color: #0491ff;
  border-radius: 5px;
  height: 45px;
  width: 150px;
}
#selectStyle{
  color: white;
  background-color: #0491ff;
  border-radius: 5px;
  height: 45px;
  width: 90px;
}
.iconSize{
  font-size: 50px;
}
.custom-alert {
  border: 2px solid #e3b505;
  height: 100px;
}

.custom-alert strong {
  color: #E3B505;
}

.select-contacts {
  background-color: #0491ff;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}

.select-contacts p {
  margin: 0;
  margin-bottom: 1em;
  color: white;
}

.textarea-ios{
  margin-right: 18px;
  margin-left: 1px ;
}

.textarea-android{
  margin-right: 18px;
  margin-left: 1px ;
}


.upload-image-popup div.vs-popup {
  width: 1200px !important;
}

.hidden-icon {
  opacity: 0;
}

.icon-container {
  position: fixed !important;
  transition: opacity 0.5s ease;
  bottom: 165px;
  right: 51px;
  cursor: pointer;
  z-index: 999;

  button i {
    font-size: 20px !important;
  }
} 
@media (max-width: 580px) {
  .icon-container {
    right: 37px;
  }
}

.notification-badge {
  display: inline-block;
  width: 19px;
  height: 19px;
  font-weight: 500;
  background-color: red;
  color: white;
  font-size: 12px;
  text-align: center;
  border-radius: 50%;
  line-height: 19px;
  right: 6.4em;
  bottom: 16.1em;
  position: fixed;
}

</style>
